<template>
  <div class="position-relative pb-5">
    <bs-page-title
      :titleLabel="fromParentTitle"
      :btnLabel="fromParentBtn"
      :btnClass="'btn-primary'"
    ></bs-page-title>
    <bs-msg-alert :alertClass="alertClass">{{
      this.alertMessage
    }}</bs-msg-alert>
    <!-- {{ this.member_obj }} -->
    <!-- {{ get_app_1000_circuit_data_valid }} -->
    <div class="row mb-5">
      <ul class="nav nav-tabs nav-fill">
        <li class="nav-item">
          <button
            type="button"
            :class="tab_switch('user')"
            @click="tab_switch_action('user')"
          >
            <i class="bi bi-person-fill me-1"></i>会員情報
          </button>
        </li>
        <li class="nav-item" v-if="not_add">
          <button
            type="button"
            :class="tab_switch('license')"
            @click="tab_switch_action('license')"
          >
            <i class="bi bi-list-check me-1"></i>ライセンス情報
          </button>
        </li>
        <li class="nav-item" v-if="not_add">
          <button
            type="button"
            :class="tab_switch('pre_ex')"
            @click="tab_switch_action('pre_ex')"
          >
            <i class="bi bi-file-earmark-medical"></i>エントリー履歴
          </button>
        </li>
      </ul>
    </div>
    <div :class="'w100 ' + tabDisplay('pre_ex')">
      <h5>エントリー履歴</h5>
      <div class="mb-40">
        <h6 class="title02 h6">参加種別選択</h6>
        <div class="row mb-24">
          <div class="col-6 col-sm-6 col-md-4 mb-2">
            <div class="page__inputGroup d-block flex-wrap">
              <div>
                <button
                  type="button"
                  :class="[
                    'btn',
                    'text-center',
                    'w-100',
                    'me-3',
                    'mb-3',
                    get_entry_type_btn_active('result')
                  ]"
                  id="input011"
                  @click="toggleEntryType"
                >
                  競技会エントリー
                </button>
              </div>
            </div>
          </div>
          <div class="col-6 col-sm-6 col-md-4 mb-2">
            <div class="page__inputGroup d-block flex-wrap">
              <div>
                <button
                  type="button"
                  :class="[
                    'btn',
                    'text-center',
                    'w-100',
                    'me-3',
                    'mb-3',
                    get_entry_type_btn_active('yakuin')
                  ]"
                  id="input011"
                  @click="toggleEntryType"
                >
                  競技役員
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section v-if="chk_entry_type('result')">
        <div class="mb-40">
          <h6 class="title02 page__h2">検索</h6>
          <div class="row gy-24">
            <div class="col-md-4">
              <p class="mb-12">
                <bs-select
                  :options="year_list"
                  :nullOption="false"
                  v-model="result_year"
                ></bs-select>
              </p>
            </div>
            <div class="col-md-4" v-if="false">
              <p class="mb-12">
                <bs-select
                  :options="year_list"
                  :nullOption="false"
                  v-model="result_year"
                ></bs-select>
              </p>
            </div>
            <div class="col-md-4">
              <p class="mb-12">
                <a class="btn btn-warning" id="input011" @click="loadResultObj">
                  検索
                </a>
              </p>
            </div>
          </div>
        </div>
        <div class="mb-40">
          <div class="" v-if="get_result_series_data.length > 0">
            <div
              v-for="series in get_result_series_data"
              :key="series.series_cd"
              class="mb-24"
            >
              <div class="mb-12">
                <h6 class="title04 page__h4">{{ series.label }}</h6>
              </div>
              <div class="mb-5">
                <table class="table table-striped">
                  <thead>
                    <tr style="border-bottom: solid 2px #ccc">
                      <th><h6 class="title06">競技会名</h6></th>
                      <!-- <th><h4 class="title06">クラス名</h4></th> -->
                      <th><h6 class="title06">順位</h6></th>
                      <!-- <th><h6 class="title06">ポイント</h6></th> -->
                      <!-- <th><h6 class="title06">昇格ポイント</h6></th> -->
                    </tr>
                  </thead>
                  <tbody
                    v-for="class_data in get_result_series_class_data(
                      series.series_cd
                    )"
                    :key="class_data.class_id"
                  >
                    <tr style="border-bottom: dashed 2px #ccc">
                      <th colspan="4">
                        <h6
                          class="title06"
                          v-html="'▼&nbsp;' + class_data.label"
                        ></h6>
                      </th>
                    </tr>
                    <tr
                      v-for="result in get_result_filter_series(
                        series.series_cd,
                        class_data.class_id
                      )"
                      :key="result.mfj_result_id"
                    >
                      <!-- <td><span v-html="result.mfj_event_sub_data_event_name"></span></td> -->
                      <td>
                        <span
                          v-html="get_result_event_name_heatchk(result)"
                        ></span>
                      </td>
                      <!-- <td><span v-html="result.mfj_class_data_name"></span></td> -->
                      <td>
                        <span
                          v-if="
                            parseInt(result.mfj_result_rank) &&
                            parseInt(result.mfj_result_rank) > 0
                          "
                          >{{ result.mfj_result_rank }}</span
                        >
                        <span v-else-if="parseInt(result.mfj_result_rank) == 0"
                          >DNF</span
                        >
                        <span v-else-if="result.mfj_result_rank == -90"
                          >DNS</span
                        >
                        <span v-else-if="result.mfj_result_rank == -99"
                          >失格</span
                        >
                      </td>
                      <td v-if="false">
                        {{ formatPoint(result.mfj_result_normal_point) }}
                      </td>
                      <td v-if="false">
                        {{ formatPoint(result.mfj_result_levelup_point) }}
                      </td>
                    </tr>
                    <tr
                      style="
                        border-bottom: solid 2px #ccc;
                        border-top: dashed 2px #ccc;
                      "
                    >
                      <th
                        v-if="false"
                        class="force-white"
                        colspan="3"
                        style="text-align: right"
                      >
                        <span
                          v-html="class_data.label + 'の合計&nbsp;▶&nbsp;'"
                        ></span>
                      </th>
                      <th class="force-white" v-if="false">
                        {{
                          formatPoint(
                            get_result_series_sum_point(
                              series.series_cd,
                              class_data.class_id
                            )
                          )
                        }}
                      </th>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div v-else-if="non_first_search_e">
            <div class="box">
              <p>検索を行ってください</p>
            </div>
          </div>
          <div v-else>
            <div class="box">
              <p>履歴データがありません。</p>
            </div>
          </div>
        </div>
      </section>
      <section v-if="chk_entry_type('yakuin')">
        <div class="mb-40">
          <div class="" v-if="yakuin_license_list.length > 0">
            <div
              v-for="license in yakuin_license_list"
              :key="license.key"
              class="mb-24"
            >
              <div class="mb-12">
                <h6 class="title04 page__h4">
                  {{ license.label }}
                </h6>
              </div>
              <div class="mb-12">
                <table class="table table-striped">
                  <thead>
                    <tr style="border-bottom: solid 2px #ccc">
                      <th><h6 class="title06">年度</h6></th>
                      <th><h6 class="title06">日程</h6></th>
                      <th><h6 class="title06">競技会名</h6></th>
                      <th><h6 class="title06">役職</h6></th>
                      <th><h6 class="title06">長/副</h6></th>
                      <th><h6 class="title06">ポイント</h6></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="yakuin in get_yakuin_filter_license(license.key)"
                      :key="yakuin.id"
                    >
                      <td>{{ yakuin.license_year }}</td>
                      <td>{{ yakuin.mfj_event_main_data_event_date_start }}</td>
                      <td>
                        <span v-html="yakuin.mfj_event_main_data_cd"></span>-
                        <span
                          v-html="yakuin.mfj_event_sub_data_event_name"
                        ></span>
                      </td>
                      <td>
                        {{
                          get_list_label(
                            yakuin.mfj_officer_position,
                            officer_position
                          )
                        }}
                      </td>
                      <td>
                        {{
                          get_list_label(
                            yakuin.mfj_officer_seihuku_flg,
                            officer_seifuku
                          )
                        }}
                      </td>
                      <td>{{ yakuin.mfj_officer_point }}</td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr style="border-top: solid 2px #ccc">
                      <th colspan="5" style="text-align: right">合計</th>
                      <th>
                        {{ formatPoint(get_yakuin_sum_point(license.key)) }}
                      </th>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </div>
          <div v-else-if="non_first_search_y">
            <div class="box">
              <p>検索中です</p>
            </div>
          </div>
          <div v-else>
            <div class="box">
              <p>履歴データがありません。</p>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div :class="'w100 ' + tabDisplay('license')">
      <h5>申請状況</h5>
      <div class="container">
        <!-- {{ application_obj }} -->
        <table class="table table-bordered">
          <thead>
            <tr>
              <th class="text-center align-middle" style="width: 10%">日時</th>
              <th class="text-center align-middle" style="width: 25%">
                申請内容
              </th>
              <th class="text-center align-middle" style="width: 25%">
                処理状況
              </th>
              <th class="text-center align-middle" style="width: 10%"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="app in application_obj" :key="app">
              <td class="">{{ app.application_date_label_YmdHi }}</td>
              <td class="">
                {{
                  get_list_label(app.application_type, application_type_list)
                }}
              </td>
              <td class="">
                {{
                  get_list_label(
                    app.application_check_type,
                    application_check_type_list
                  )
                }}
              </td>
              <td class="">
                <button
                  type="button"
                  class="btn btn-light btn-outline-secondary btn-sm"
                  @click="go_application(app.id)"
                >
                  詳細
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <h5>保険</h5>
      <!-- {{ insurance_type_list }} -->
      <div class="container">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th class="" style="width: 18%">種別</th>
              <th class="" style="width: 20%">年度</th>
              <th class="" style="width: 10%">状態</th>
              <th style="width: auto" colspan="2">期間</th>
              <th class="" style="width: 7%"></th>
            </tr>
          </thead>
          <tbody
            v-if="
              Array.isArray(insurance_year_sort) &&
              insurance_year_sort.length > 0
            "
          >
            <tr
              v-for="(insurance, index) in insurance_year_sort"
              :key="index"
              v-show="insurance_visible_tr(index)"
            >
              <td>
                <div class="">
                  {{
                    get_list_label(
                      insurance.insurance_type,
                      insurance_type_list
                    )
                  }}
                </div>
              </td>
              <td>
                <div class="" v-if="change_mode">
                  <span>{{ insurance.sports_year }}年</span>
                </div>
                <div class="input-group input-group-sm" v-else>
                  <input
                    type="text"
                    v-model="insurance.sports_year"
                    class="form-control form-control-sm"
                  />
                  <span class="input-group-text">年</span>
                </div>
              </td>
              <td>
                <div class="" v-if="change_mode">
                  <span v-if="insurance.fixed == 1">有効</span>
                  <span v-else-if="insurance.fixed == 0">無効</span>
                </div>
                <div v-else>
                  <div class="input-group input-group-sm">
                    <bs-select
                      :options="insurance_fix_list"
                      :nullOption="false"
                      v-model="insurance.fixed"
                      :classParam="'form-select-sm'"
                    ></bs-select>
                  </div>
                </div>
              </td>
              <td colspan="2">
                <div class="input-group input-group-sm" v-if="change_mode">
                  <input
                    type="text"
                    v-model="insurance.start_date"
                    class="form-control-plaintext"
                  />
                  <span class="input-group-text">〜</span>
                  <input
                    type="text"
                    v-model="insurance.end_date"
                    class="form-control-plaintext"
                  />
                </div>
                <div class="input-group input-group-sm" v-else>
                  <input
                    type="datetime-local"
                    v-model="insurance.start_date"
                    class="form-control"
                  />
                  <span class="input-group-text">〜</span>
                  <input
                    type="datetime-local"
                    v-model="insurance.end_date"
                    class="form-control"
                  />
                </div>
              </td>
              <td class="text-center align-middle">
                <span v-if="change_mode">-</span>
                <button
                  v-else
                  type="button"
                  class="btn btn-warning btn-sm"
                  @click="del_member_insurance(insurance.id)"
                >
                  <i class="bi bi-trash"></i>
                </button>
              </td>
            </tr>
          </tbody>
          <tbody
            v-if="
              change_mode &&
              Array.isArray(member_obj.insurance) &&
              member_obj.insurance.length >= this.insurance_visible_count
            "
          >
            <tr>
              <td colspan="5">
                <div class="text-center">
                  <button
                    type="button"
                    class="btn btn-light btn-outline-secondary btn-sm"
                    @click="toggle_insurance_visible()"
                  >
                    <span v-if="insurance_visible_sw">戻す</span>
                    <span v-else>全件表示する</span>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
          <tbody v-else-if="!change_mode">
            <tr
              v-for="(insurance, index) in add_insurance_obj"
              :key="insurance"
            >
              <td>
                <div class="">
                  <bs-select
                    :options="insurance_type_list"
                    :nullOption="true"
                    v-model="insurance.insurance_type"
                    :classParam="'form-select-sm'"
                  ></bs-select>
                </div>
              </td>
              <td>
                <div class="input-group input-group-sm">
                  <input
                    type="text"
                    v-model="insurance.sports_year"
                    class="form-control form-control-sm"
                  />
                  <span class="input-group-text">年</span>
                </div>
              </td>
              <td>
                <div class="input-group input-group-sm">
                  <bs-select
                    :options="insurance_fix_list"
                    :nullOption="false"
                    v-model="insurance.fixed"
                    :classParam="'form-select-sm'"
                  ></bs-select>
                </div>
              </td>
              <td colspan="2">
                <div class="input-group input-group-sm">
                  <input
                    type="date"
                    v-model="insurance.start_date"
                    class="form-control form-control-sm"
                  />
                  <span class="input-group-text">〜</span>
                  <input
                    type="date"
                    v-model="insurance.end_date"
                    class="form-control form-control-sm"
                  />
                </div>
              </td>
              <td class="text-center align-middle">
                <button
                  type="button"
                  class="btn btn-warning btn-sm"
                  @click="del_add_insurance(index)"
                >
                  <i class="bi bi-trash"></i>
                </button>
              </td>
            </tr>
            <tr>
              <td colspan="5">
                <button
                  type="button"
                  class="btn btn-light btn-outline-secondary btn-sm"
                  @click="add_insurance"
                >
                  <i class="bi bi-plus"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <h5>取得ライセンス</h5>
      <div class="container">
        <table
          class="table table-bordered"
          v-for="l_year in get_year_list_have_license"
          :key="l_year"
        >
          <thead class="">
            <tr class="bg-light">
              <th colspan="7">{{ l_year }}年</th>
            </tr>
            <tr class="bg-light">
              <th class="" style="width: 16%">
                <div class="mb-1 pb-1 border-bottom">種別</div>
                <div>種目</div>
              </th>
              <th class="" style="width: 18%">
                <div class="mb-1 pb-1 border-bottom">ライセンス</div>
                <div>年度</div>
              </th>
              <th class="" style="width: 10%">
                <div class="mb-1 pb-1 border-bottom">講習</div>
                <div>支払</div>
              </th>
              <th class="" style="width: 10%"></th>
              <th style="width: 30%" colspan="2">
                <div class="mb-1 pb-1 border-bottom">期間</div>
                <div>状態</div>
              </th>
              <th class="" style="width: 7%"></th>
            </tr>
          </thead>
          <tbody v-for="n in [1, 2, 3, 4]" :key="n">
            <tr
              v-for="license in license_filter_sort(n, l_year)"
              :key="license"
            >
              <td>
                <!-- {{ license }} -->
                <div class="mb-1 pb-1 border-bottom">
                  <span v-if="n == 1">競技ライセンス</span>
                  <span v-if="n == 2">競技役員</span>
                  <span v-if="n == 3">講師</span>
                  <span v-if="n == 4">PitCrew</span>
                </div>
                <div class="">
                  {{ get_list_label(license.license_event_cd, event_cd_list) }}
                </div>
              </td>
              <td>
                <div class="mb-1 pb-1 border-bottom">
                  {{ get_list_label(license.license_cd, license_cd_list) }}
                </div>
                <div class="" v-if="change_mode">
                  <span>{{ license.license_year }}年</span>
                </div>
                <div class="input-group input-group-sm" v-else>
                  <input
                    type="text"
                    v-model="license.license_year"
                    class="form-control form-control-sm"
                  />
                  <span class="input-group-text">年</span>
                </div>
              </td>
              <td>
                <div class="mb-1 pb-1 border-bottom">
                  <span v-if="change_mode">{{
                    get_list_label(license.fixed, fix_fin_list)
                  }}</span>
                  <bs-select
                    v-else
                    :options="fix_fin_list"
                    :nullOption="false"
                    v-model="license.fixed"
                    :classParam="'form-select-sm'"
                  ></bs-select>
                </div>
                <div class="">
                  <span v-if="change_mode">{{
                    get_list_label(license.payment_flg, payment_fin_list)
                  }}</span>
                  <bs-select
                    v-else
                    :options="payment_fin_list"
                    :nullOption="false"
                    v-model="license.payment_flg"
                    :classParam="'form-select-sm'"
                  ></bs-select>
                </div>
              </td>
              <td>
                <div v-if="change_mode" class="mb-1 pb-1 border-bottom">
                  {{ license.issue_date }}
                </div>
                <div v-else class="mb-1 pb-1 border-bottom">
                  <input
                    type="datetime-local"
                    v-model="license.issue_date"
                    class="form-control-sm form-control"
                  />
                </div>
                <div class="">
                  <span v-if="change_mode">{{
                    get_list_label(license.movie_viewed, fix_fin_list)
                  }}</span>
                  <bs-select
                    v-else
                    :options="fix_fin_list"
                    :nullOption="false"
                    v-model="license.movie_viewed"
                    :classParam="'form-select-sm'"
                  ></bs-select>
                </div>
              </td>
              <td colspan="2">
                <div class="mb-1 pb-1 border-bottom">
                  <div class="input-group input-group-sm" v-if="change_mode">
                    <input
                      type="text"
                      v-model="license.license_term_start_date"
                      class="form-control-plaintext"
                    />
                    <span class="input-group-text">〜</span>
                    <input
                      type="text"
                      v-model="license.license_term_end_date"
                      class="form-control-plaintext"
                    />
                  </div>
                  <div class="input-group input-group-sm" v-else>
                    <input
                      type="date"
                      v-model="license.license_term_start_date"
                      class="form-control"
                    />
                    <span class="input-group-text">〜</span>
                    <input
                      type="date"
                      v-model="license.license_term_end_date"
                      class="form-control"
                    />
                  </div>
                </div>
                <div>
                  <span v-if="change_mode">{{
                    get_list_label(license.stat, license_stat_list)
                  }}</span>
                  <bs-select
                    v-else
                    :options="license_stat_list"
                    :nullOption="false"
                    v-model="license.stat"
                    :classParam="'form-select-sm'"
                  ></bs-select>
                </div>
              </td>
              <td class="text-center align-middle">
                <div>
                  <span v-if="change_mode">-</span>
                  <button
                    v-else
                    type="button"
                    class="btn btn-warning btn-sm"
                    @click="del_member_license(license.id)"
                  >
                    <i class="bi bi-trash"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-if="!change_mode">
        <table class="table table-bordered">
          <thead class="">
            <tr class="bg-light">
              <th colspan="7">ライセンス追加登録</th>
            </tr>
            <tr class="bg-light">
              <th class="" style="width: 16%">
                <div class="mb-1 pb-1 border-bottom">種別</div>
                <div>種目</div>
              </th>
              <th class="" style="width: 18%">
                <div class="mb-1 pb-1 border-bottom">ライセンス</div>
                <div>年度</div>
              </th>
              <th class="" style="width: 10%">
                <div class="mb-1 pb-1 border-bottom">講習</div>
                <div>支払</div>
              </th>
              <th class="" style="width: 10%"></th>
              <th style="width: 30%" colspan="2">
                <div class="mb-1 pb-1 border-bottom">期間</div>
                <div>状態</div>
              </th>
              <th class="" style="width: 7%"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(license, index) in add_license_obj" :key="license">
              <td>
                <div class="mb-1 pb-1 border-bottom">
                  <bs-select
                    :options="license_class_list"
                    :nullOption="true"
                    v-model="license.license_class"
                    :classParam="'form-select-sm'"
                  ></bs-select>
                </div>
                <div>
                  <bs-select
                    :options="event_cd_list"
                    :nullOption="true"
                    v-model="license.license_event_cd"
                    :classParam="'form-select-sm'"
                  ></bs-select>
                </div>
              </td>
              <td>
                <div class="mb-1 pb-1 border-bottom input-group input-group-sm">
                  <input
                    type="text"
                    v-model="license.license_year"
                    class="form-control form-control-sm"
                  />
                  <span class="input-group-text">年</span>
                </div>
                <div>
                  <bs-select
                    :options="
                      license_cd_list_filter_event(
                        license.license_event_cd,
                        license.license_class
                      )
                    "
                    :nullOption="true"
                    v-model="license.license_cd"
                    :classParam="'form-select-sm'"
                  ></bs-select>
                </div>
              </td>
              <td>
                <div class="mb-1 pb-1 border-bottom">
                  <bs-select
                    :options="fix_fin_list"
                    :nullOption="false"
                    v-model="license.fixed"
                    :classParam="'form-select-sm'"
                  ></bs-select>
                </div>
                <div>
                  <bs-select
                    :options="payment_fin_list"
                    :nullOption="false"
                    v-model="license.payment_flg"
                    :classParam="'form-select-sm'"
                  ></bs-select>
                </div>
              </td>
              <td>
                <div class="mb-1 pb-1 border-bottom">
                  <input
                    type="date"
                    v-model="license.issue_date"
                    class="form-control form-control-sm"
                  />
                </div>
                <div>
                  <bs-select
                    :options="fix_fin_list"
                    :nullOption="false"
                    v-model="license.movie_viewed"
                    :classParam="'form-select-sm'"
                  ></bs-select>
                </div>
              </td>
              <td colspan="2">
                <div class="input-group input-group-sm">
                  <input
                    type="date"
                    v-model="license.license_term_start_date"
                    class="form-control form-control-sm"
                  />
                  <span class="input-group-text">〜</span>
                  <input
                    type="date"
                    v-model="license.license_term_end_date"
                    class="form-control form-control-sm"
                  />
                </div>
              </td>
              <td class="text-center align-middle">
                <button
                  type="button"
                  class="btn btn-warning btn-sm"
                  @click="del_add_license(index)"
                >
                  <i class="bi bi-trash"></i>
                </button>
              </td>
            </tr>
            <tr>
              <td colspan="7">
                <button
                  type="button"
                  class="btn btn-light btn-outline-secondary btn-sm"
                  @click="add_license"
                >
                  <i class="bi bi-plus"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div :class="'w100 ' + tabDisplay('user')">
      <div class="row mb-1 pb-1 border-bottom">
        <div class="col-2">
          <p class="fs-6 mb-0 pb-0">ライセンス情報</p>
        </div>
      </div>
      <div class="container">
        <div class="row mb-3">
          <div class="col-2">
            <p class="text-center py-1 fs-7">年度</p>
          </div>
          <div class="col-3">
            <div class="input-group">
              <input
                type="text"
                :class="input_class"
                id="last_sports_year"
                placeholder="年度"
                v-model="member_obj.last_sports_year"
                :disabled="input_readonly"
              />
              <span class="input-group-text">年度</span>
            </div>
          </div>
        </div>
        <template
          v-if="
            Array.isArray(member_obj.insurance) &&
            member_obj.insurance.length > 0
          "
        >
          <div
            class="row mb-3"
            v-for="insurance in [...insurance_year_sort].slice(0, 1)"
            :key="insurance"
          >
            <div class="col-2 text-center">
              <p class="pt-1 pb-0 mb-0 fs-7">スポーツ安全保険</p>
              <span class="fs-9">(最新一件)</span>
            </div>
            <div class="col-3">
              <input
                v-if="change_mode"
                :value="
                  !insurance.insurance_type || insurance.insurance_type === '0'
                    ? '未選択'
                    : get_list_label(
                        insurance.insurance_type,
                        insurance_type_list
                      )
                "
                :class="input_class"
                :readonly="input_readonly"
              />
              <bs-select
                v-else
                :options="insurance_type_list"
                :nullOption="false"
                v-model="insurance.insurance_type"
              ></bs-select>
            </div>
            <div class="col-6">
              <div class="input-group">
                <input
                  type="text"
                  :class="input_class"
                  placeholder=""
                  v-model="insurance.start_date_date"
                  disabled="true"
                />
                <span class="input-group-text">〜</span>
                <input
                  type="text"
                  :class="input_class"
                  placeholder=""
                  v-model="insurance.end_date_date"
                  disabled="true"
                />
              </div>
            </div>
          </div>
        </template>
        <div class="row mb-3">
          <div class="col-2">
            <p class="text-center py-1 fs-7">MFJライセンスNo.</p>
          </div>
          <div class="col-3">
            <input
              type="text"
              :class="input_class"
              placeholder="ライセンスNo"
              v-model="member_obj.license_no"
              v-if="not_add || member_obj.license_no"
              :readonly="input_readonly_f"
            />
            <input
              type="text"
              :class="input_class"
              placeholder="ライセンスNo"
              v-model="(get_license_no_stock || {}).license_no"
              v-else
              :readonly="input_readonly_f"
            />
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-2">
            <p class="text-center py-1 fs-7">所属</p>
          </div>
          <div class="col-3">
            <input
              v-if="change_mode"
              :value="
                get_list_label(member_obj.affiliation, affiliation_type_list)
              "
              :class="input_class"
              :readonly="input_readonly"
            />
            <bs-select
              v-else
              :options="affiliation_type_list"
              :nullOption="false"
              v-model="member_obj.affiliation"
            ></bs-select>
          </div>
          <div class="col-2">
            <p class="text-center py-1 fs-7">管理</p>
          </div>
          <div class="col-3">
            <input
              v-if="change_mode"
              :value="get_list_label(member_obj.affiliation, sec_cd_list)"
              :class="input_class"
              :readonly="input_readonly"
            />
            <bs-select
              v-else
              :options="sec_cd_list"
              :nullOption="false"
              v-model="member_obj.sec_cd"
            ></bs-select>
          </div>
        </div>
        <div class="row mb-1 pb-1 border-bottom">
          <div class="col-2">
            <p class="fs-6 mb-0 pb-0">ログイン情報</p>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-2">
            <p class="text-center py-1 fs-7">ログインID</p>
          </div>
          <div class="col-6">
            <div class="input-group">
              <input
                v-if="change_mode"
                type="text"
                :class="input_class"
                placeholder="ログインID"
                v-model="member_obj.login_id"
                :disabled="input_readonly"
              />
              <input
                v-else
                type="text"
                :class="chk_input_class('login_id', 'input')"
                placeholder="ログインID"
                v-model="member_obj.login_id"
              />
            </div>
            <div v-if="chk_error('login_id')" class="text-danger">
              {{ get_error_msg('login_id') }}
            </div>
          </div>
        </div>
        <div class="row mb-3" v-if="!change_mode && !not_add">
          <div class="col-2">
            <p class="text-center py-1 fs-7">ログインPW</p>
          </div>
          <div :class="pass_chg_sw ? 'col-10' : 'col-4'">
            <div class="input-group">
              <label class="input-group-text" for="PassChgSw">
                <input
                  class="form-check-input mt-0 me-2"
                  id="PassChgSw"
                  type="checkbox"
                  v-model="pass_chg_sw"
                />
                変更
              </label>
              <input
                type="text"
                :class="input_class"
                placeholder="パスワード"
                v-model="login_pass_input"
                :disabled="!pass_chg_sw ? 'disabled' : false"
              />
              <span class="input-group-text" v-if="pass_chg_sw">確認用</span>
              <input
                type="text"
                :class="input_class"
                placeholder="パスワード確認用"
                v-model="pass_chg_confirm"
                v-if="pass_chg_sw"
              />
            </div>
          </div>
        </div>
        <div class="row mb-1 pb-1 border-bottom">
          <div class="col-2">
            <p class="fs-6 mb-0 pb-0">個人情報</p>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-2">
            <p class="text-center py-1 fs-7">氏名</p>
          </div>
          <div class="col-3">
            <input
              type="text"
              :class="input_class"
              id="Name_1"
              placeholder="姓"
              v-model="member_obj.name_1"
              :readonly="input_readonly"
            />
          </div>
          <div class="col-3">
            <input
              type="text"
              :class="input_class"
              id="Name_2"
              placeholder="名"
              v-model="member_obj.name_2"
              :readonly="input_readonly"
            />
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-2">
            <p class="text-center py-1 fs-7">カナ</p>
          </div>
          <div class="col-3">
            <input
              type="text"
              :class="input_class"
              id="Yomi_1"
              placeholder="セイ"
              v-model="member_obj.yomi_1"
              :readonly="input_readonly"
            />
          </div>
          <div class="col-3">
            <input
              type="text"
              :class="input_class"
              id="Yomi_2"
              placeholder="メイ"
              v-model="member_obj.yomi_2"
              :readonly="input_readonly"
            />
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-2">
            <p class="text-center py-1 fs-7">生年月日</p>
          </div>
          <div class="col-3">
            <input
              v-if="change_mode"
              type="text"
              :class="input_class"
              id="BirthDate"
              placeholder="生年月日"
              v-model="member_obj.birth_date"
              :readonly="input_readonly_f"
            />
            <input
              v-else
              type="date"
              :class="input_class"
              id="BirthDate"
              placeholder="生年月日"
              v-model="member_obj.birth_date"
              :readonly="input_readonly_f"
            />
          </div>
          <div class="col-3">
            <input
              type="text"
              :class="input_class"
              placeholder="生年月日(和暦)"
              :value="get_wareki(member_obj.birth_date)"
              :readonly="input_readonly_f"
            />
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-2">
            <p class="text-center py-1 fs-7">年齢</p>
          </div>
          <div class="col-4">
            <div class="input-group">
              <span class="input-group-text">満年齢</span>
              <input
                type="text"
                :value="calc_age(member_obj.birth_date)"
                :class="input_class"
                placeholder="年齢"
                disabled="true"
              />
            </div>
          </div>
          <div class="col-4">
            <div class="input-group">
              <span class="input-group-text">スポーツ年齢</span>
              <input
                type="text"
                :value="calc_sports_age(member_obj.birth_date)"
                :class="input_class"
                placeholder="年齢"
                disabled="true"
              />
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-2">
            <p class="text-center py-1 fs-7">性別</p>
          </div>
          <div class="col-3">
            <input
              v-if="change_mode"
              type="text"
              :value="get_sex_type_label(member_obj.sex_type)"
              :class="input_class"
              :readonly="input_readonly_f ? 'readonly' : 'false'"
            />
            <bs-select
              v-else-if="!change_mode"
              :options="sex_type_list"
              :nullOption="false"
              id="SexType"
              v-model="member_obj.sex_type"
            ></bs-select>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-2">
            <p class="text-center py-1 fs-7">顔写真</p>
          </div>
          <div class="col-3">
            <div class="w-100" v-if="typeof get_assets(100, 0) === 'object'">
              <img :src="(get_assets(100, 0) || {}).path" class="w-100" />
            </div>
          </div>
          <div class="col-6">
            <input
              type="file"
              v-if="!change_mode"
              :class="input_class"
              id="file_up_input_100"
              @change="selectedFile($event, 100)"
            />
          </div>
        </div>
      </div>
      <div class="row mb-1 pb-1 border-bottom">
        <div class="col-2">
          <p class="fs-6 mb-0 pb-0">住所・連絡先</p>
        </div>
      </div>
      <div
        class="container"
        v-for="(prof, index) in member_obj.profile"
        :key="prof"
      >
        <div class="row mb-3">
          <div class="col-2">
            <p class="text-center py-1 fs-7">郵便番号</p>
          </div>
          <div class="col-4">
            <div class="input-group">
              <input
                type="text"
                :class="input_class"
                placeholder="郵便番号"
                v-model="prof.postal_cd"
                :readonly="input_readonly"
              />
              <button
                v-if="!change_mode"
                type="button"
                class="btn btn-light btn-outline-secondary"
                @click="get_address(prof.postal_cd, index)"
              >
                郵便番号検索
              </button>
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-2">
            <p class="text-center py-1 fs-7">都道府県</p>
          </div>
          <div class="col-4">
            <input
              v-if="change_mode"
              type="text"
              :class="input_class"
              :readonly="input_readonly"
              :value="get_pref_label(prof.pref_cd)"
            />
            <bs-select
              v-else
              :options="pref_list"
              :nullOption="true"
              id="SexType"
              v-model="prof.pref_cd"
            ></bs-select>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-2">
            <p class="text-center py-1 fs-7">市区町村・番地</p>
          </div>
          <div class="col-10">
            <input
              type="text"
              :class="input_class"
              placeholder="市区町村・番地"
              v-model="prof.address_1"
              :readonly="input_readonly"
            />
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-2">
            <p class="text-center py-1 fs-7">建物名・室号</p>
          </div>
          <div class="col-10">
            <input
              type="text"
              :class="input_class"
              placeholder="建物名・室号"
              v-model="prof.address_2"
              :readonly="input_readonly"
            />
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-2">
            <p class="text-center py-1 fs-7">連絡先電話番号1</p>
          </div>
          <div class="col-5">
            <input
              type="text"
              :class="input_class"
              placeholder="連絡先電話番号1"
              v-model="prof.tel_1"
              :readonly="input_readonly"
            />
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-2">
            <p class="text-center py-1 fs-7">連絡先電話番号2</p>
          </div>
          <div class="col-5">
            <input
              type="text"
              :class="input_class"
              placeholder="連絡先電話番号2"
              v-model="prof.tel_2"
              :readonly="input_readonly"
            />
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-2">
            <p class="text-center py-1 fs-7">メールアドレス1</p>
          </div>
          <div class="col-10">
            <input
              type="text"
              :class="input_class"
              placeholder="メールアドレス1"
              v-model="member_obj.mail_1"
              :readonly="input_readonly"
            />
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-2">
            <p class="text-center py-1 fs-7">メールアドレス2</p>
          </div>
          <div class="col-10">
            <input
              type="text"
              :class="input_class"
              placeholder="メールアドレス2"
              v-model="member_obj.mail_2"
              :readonly="input_readonly"
            />
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-2">
            <p class="text-center py-1 fs-7">メールマガジン配信希望</p>
          </div>
          <div class="col-4">
            <input
              v-if="change_mode"
              :value="get_request_cd_label(member_obj.mail_flg)"
              :class="input_class"
              :readonly="input_readonly"
            />
            <bs-select
              v-else
              :options="request_type_list"
              :nullOption="true"
              v-model="member_obj.mail_flg"
            ></bs-select>
          </div>
        </div>
      </div>

      <div class="row mb-1 pb-1 border-bottom">
        <div class="col-2">
          <p class="fs-6 mb-0 pb-0">ライセンス申請情報</p>
        </div>
        <!-- ライセンス関連の操作が制限されている場合の警告表示 -->
        <div
          v-if="isAllLicenseProcessingDisabled()"
          class="alert alert-warning"
        >
          <i class="bi bi-exclamation-triangle me-2"></i>
          利用停止中または移籍中のため、ライセンス手続きは行えません
        </div>
      </div>

      <!-- 本人確認書類 -->
      <div class="row mb-3">
        <div class="col-2">
          <p class="text-center py-1 fs-7">本人確認書類</p>
        </div>
        <div class="col-3">
          <input
            v-if="change_mode && not_add"
            :value="
              get_list_label(member_obj.identify_type, member_document_list)
            "
            :class="input_class"
            :readonly="input_readonly"
          />
          <bs-select
            v-else
            :options="member_document_list"
            :nullOption="true"
            v-model="member_obj.identify_type"
            nullText="未選択"
            :disabled="isAllLicenseProcessingDisabled()"
          ></bs-select>
        </div>
        <!-- ファイルアップロード部分 -->
        <div class="col-4">
          <div>
            <div
              class="w-100"
              v-if="
                typeof get_assets(400, 0) === 'object' &&
                (get_assets(400, 0) || {}).path
              "
            >
              <a
                v-if="superuser_sw"
                href="(get_assets(400, 0) || {}).path"
                class="btn btn-light btn-outline-secondary"
                >ファイル閲覧</a
              >
            </div>
          </div>
        </div>
        <div
          class="col-3"
          v-if="
            !change_mode &&
            !(
              typeof get_assets(400, 0) === 'object' &&
              (get_assets(400, 0) || {}).path
            )
          "
        >
          <input
            type="file"
            :class="input_class"
            id="file_up_input_400"
            @change="selectedFile($event, 400)"
            :disabled="isAllLicenseProcessingDisabled()"
          />
        </div>
        <!-- 承認関連 -->
        <div class="offset-2 col-4" v-if="false">
          <div class="input-group">
            <span class="input-group-text" v-if="member_obj.identify_sw"
              >承認済</span
            >
            <button
              @click="set_member_identify"
              type="button"
              class="btn btn-light btn-outline-secondary"
              v-else-if="
                superuser_sw &&
                !member_obj.identify_sw &&
                member_obj.identify_manage_id == 0
              "
              :disabled="isAllLicenseProcessingDisabled()"
            >
              承認する
            </button>
            <input
              type="date"
              :class="input_class"
              placeholder=""
              v-model="member_obj.identify_date_date"
              disabled="true"
            />
            <button
              @click="clear_member_identify"
              type="button"
              class="btn btn-light btn-outline-secondary"
              v-if="
                superuser_sw &&
                !member_obj.identify_sw &&
                member_obj.identify_manage_id != 0
              "
              :disabled="isAllLicenseProcessingDisabled()"
            >
              解除
            </button>
          </div>
        </div>
        <div class="col-3" v-if="false">
          <div class="input-group">
            <span class="input-group-text">承認者</span>
            <input
              type="text"
              :class="input_class"
              placeholder=""
              v-model="member_obj.identify_manage_label"
              disabled="true"
            />
          </div>
        </div>
      </div>

      <!-- サーキットライセンス -->
      <div class="mb-3 row" v-if="chk_app_1000_circuit_data_valid">
        <div class="col-2">
          <p class="text-center py-1 fs-7">サーキットライセンス</p>
        </div>
        <div
          class="col-10"
          v-for="order in get_app_1000_circuit_data_valid"
          :key="order.id"
        >
          <div class="row">
            <div class="col-5">サーキット</div>
            <div class="col-7">
              <input
                :value="
                  get_list_label(order.join_3hour_circuit_id, circuit_list)
                "
                :class="input_class"
                :readonly="input_readonly"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-5">サーキットライセンス</div>
            <div class="col-7">
              <input
                :value="order.join_3hour_circuit_license_no"
                :class="input_class"
                :readonly="input_readonly"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="mb-3 row" v-if="false">
        <div class="col-2">
          <p class="text-center py-1 fs-7">サーキットライセンス</p>
        </div>
        <div class="col-10">
          <div
            class="mb-1"
            v-if="
              typeof member_obj.circuit_license === 'object' &&
              member_obj.circuit_license.length > 0
            "
          >
            <div
              class="input-group mb-2"
              v-for="(circuit_license, index) in member_obj.circuit_license"
              :key="circuit_license"
            >
              <span class="input-group-text">[{{ index + 1 }}]サーキット</span>
              <input
                v-if="change_mode"
                :value="
                  get_list_label(circuit_license.circuit_id, circuit_list)
                "
                :class="input_class"
                :readonly="input_readonly"
              />
              <bs-select
                v-else
                :options="circuit_list"
                :nullOption="true"
                v-model="circuit_license.circuit_id"
                :disabled="isAllLicenseProcessingDisabled()"
              ></bs-select>
              <span class="input-group-text"
                >[{{ index + 1 }}]ライセンスNo.</span
              >
              <input
                type="text"
                :class="input_class"
                placeholder="サーキットライセンスNo."
                v-model="circuit_license.circuit_license_no"
                :disabled="isAllLicenseProcessingDisabled()"
              />
            </div>
          </div>
          <div v-if="!change_mode">
            <button
              type="button"
              class="btn btn-light btn-outline-secondary"
              @click="add_circuit_license"
              :disabled="isAllLicenseProcessingDisabled()"
            >
              <i class="bi bi-plus"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- 所属クラブ -->
      <div class="mb-3 row">
        <div class="col-2">
          <p class="text-center py-1 fs-7">所属クラブ</p>
        </div>
        <div class="col-10">
          <div
            class="mb-1"
            v-if="
              typeof member_obj.belong_club === 'object' &&
              member_obj.belong_club.length > 0
            "
          >
            <div
              class="input-group mb-2"
              v-for="group in member_obj.belong_club"
              :key="group"
            >
              <span class="input-group-text">クラブ</span>
              <!-- クラブ名は常に表示のみ -->
              <!-- 表示モード -->
              <input
                v-if="change_mode"
                :value="get_list_label(group.group_id, group_list)"
                :class="input_class"
                :readonly="input_readonly"
              />
              <!-- 編集モード -->
              <input
                v-else
                :value="get_list_label(group.group_id, group_list)"
                :class="input_class"
                readonly
              />
              <span class="input-group-text">所属状況</span>
              <input
                v-if="change_mode"
                :value="get_list_label(group.stat, belong_club_status_list)"
                :class="input_class"
                readonly
              />
              <!-- 編集モード時のみ所属状況を変更可能 -->
              <bs-select
                v-else
                :options="belong_club_status_list"
                :nullOption="false"
                v-model="group.stat"
                :disabled="isAllLicenseProcessingDisabled()"
              ></bs-select>
            </div>
            <!-- {{ dev_msg('クラブ登録等の仕組み実装後に') }}
            {{ dev_msg('所属クラブ退会は状況から脱退を選択して更新。') }} -->
          </div>
        </div>
      </div>

      <!-- 年度継続承認 -->
      <div class="row mb-3">
        <div class="col-2">
          <p class="text-center py-1 fs-7">年度継続承認</p>
        </div>
        <div class="col-4">
          <input
            v-if="change_mode"
            :value="
              get_list_label(
                member_obj.continue_app_type,
                continue_app_type_list
              )
            "
            :class="input_class"
            :readonly="input_readonly"
          />
          <bs-select
            v-else
            :options="continue_app_type_list"
            :nullOption="true"
            v-model="member_obj.continue_app_type"
            :disabled="isAllLicenseProcessingDisabled()"
          ></bs-select>
        </div>
      </div>
      <!-- ブランク時データ退避設定 -->
      <div class="row mb-3">
        <div class="col-2">
          <p class="text-center py-1 fs-7">ブランク時データ退避設定</p>
        </div>
        <div class="col-4">
          <input
            v-if="change_mode"
            :value="
              member_obj.continue_data_save_type === '1'
                ? '退避する'
                : '退避しない'
            "
            :class="input_class"
            :readonly="input_readonly"
          />
          <bs-select
            v-else
            :options="continue_data_save_type_obj"
            :nullOption="false"
            v-model="member_obj.continue_data_save_type"
            :disabled="isAllLicenseProcessingDisabled()"
          ></bs-select>
        </div>
      </div>

      <!-- 入会申請日 -->
      <div class="row mb-3" v-if="false">
        <div class="col-2">
          <p class="text-center py-1 fs-7">入会申請日</p>
        </div>
        <div class="col-4">
          <input
            type="date"
            :class="input_class"
            placeholder="入会申請日"
            v-model="member_obj.application_date_date"
            :readonly="input_readonly"
            :disabled="isAllLicenseProcessingDisabled()"
          />
        </div>
      </div>
      <div class="row mb-3" v-if="false">
        <div class="col-2">
          <p class="text-center py-1 fs-7">入会承認日</p>
        </div>
        <div class="col-4">
          <div class="input-group">
            <span class="input-group-text" v-if="member_obj.permission_sw"
              >承認済</span
            >
            <button
              @click="set_member_permission"
              type="button"
              class="btn btn-light btn-outline-secondary"
              v-else-if="
                superuser_sw &&
                !change_mode &&
                !member_obj.permission_sw &&
                member_obj.permission_manage_id == 0
              "
            >
              承認する
            </button>
            <!-- <span class="input-group-text" v-else>
                未承認</span> -->
            <input
              type="date"
              :class="input_class"
              placeholder=""
              v-model="member_obj.permission_date_date"
              disabled="true"
            />
            <button
              @click="clear_member_permission"
              type="button"
              class="btn btn-light btn-outline-secondary"
              v-if="
                superuser_sw &&
                !member_obj.permission_sw &&
                member_obj.permission_manage_id != 0
              "
            >
              解除
            </button>
          </div>
        </div>
        <div class="col-3" v-if="false">
          <div class="input-group">
            <span class="input-group-text">承認者</span>
            <input
              type="text"
              :class="input_class"
              placeholder=""
              v-model="member_obj.permission_manage_label"
              :disabled="!superuser_sw || input_readonly"
            />
          </div>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-2">
          <p class="text-center py-1 fs-7">入会日</p>
        </div>
        <div class="col-4">
          <input
            type="date"
            :class="input_class"
            placeholder="入会日"
            v-model="member_obj.payment_date_date"
            :disabled="!superuser_sw || input_readonly"
          />
        </div>
      </div>
      <!-- {{ dev_msg('受講日はライセンス毎に設定') }} -->
      <div class="row mb-1 pb-1 border-bottom">
        <div class="col-2">
          <p class="fs-6 mb-0 pb-0">システム設定</p>
        </div>
      </div>
      <div class="mb-3 row">
        <div class="col-2">
          <p class="text-center py-1 fs-7">利用停止</p>
        </div>
        <div class="col-10">
          <div
            class="mb-1"
            v-if="
              typeof member_obj.system_exclude === 'object' &&
              member_obj.system_exclude.length > 0
            "
          >
            <div
              class="mb-2"
              v-for="(system_exclude, index) in member_obj.system_exclude"
              :key="system_exclude"
            >
              <div class="input-group mb-1">
                <span class="input-group-text">停止理由[{{ index + 1 }}]</span>
                <!-- 表示モード -->
                <input
                  v-if="change_mode"
                  :value="
                    get_list_label(system_exclude.exclude_cd, exclude_list)
                  "
                  :class="input_class"
                  readonly
                />
                <!-- 編集モード -->
                <bs-select
                  v-else
                  :options="exclude_list"
                  :nullOption="true"
                  v-model="system_exclude.exclude_cd"
                  :disabled="isLicenseProcessingDisabled(system_exclude)"
                ></bs-select>

                <!-- メモ欄 -->
                <span
                  class="input-group-text"
                  v-if="!change_mode && system_exclude.exclude_cd > 0"
                  >メモ</span
                >
                <textarea
                  v-if="!change_mode && system_exclude.exclude_cd > 0"
                  :class="input_class"
                  v-model="system_exclude.note"
                  placeholder="停止・退会の理由。移籍先当"
                  :readonly="isLicenseProcessingDisabled(system_exclude)"
                ></textarea>
              </div>

              <!-- 期間設定部分 -->
              <div class="input-group" v-if="system_exclude.exclude_cd > 0">
                <span class="input-group-text">期間</span>
                <input
                  type="date"
                  :class="input_class"
                  v-model="system_exclude.start_date_date"
                  :readonly="isLicenseProcessingDisabled(system_exclude)"
                />
                <span class="input-group-text">〜</span>
                <input
                  type="date"
                  :class="input_class"
                  v-model="system_exclude.end_date_date"
                  :readonly="isLicenseProcessingDisabled(system_exclude)"
                />
                <span class="input-group-text">記入者</span>
                <input
                  type="text"
                  :class="input_class"
                  v-model="system_exclude.manage_label"
                  :readonly="isLicenseProcessingDisabled(system_exclude)"
                />
                <!-- 削除ボタン -->
                <button
                  v-if="
                    !change_mode && !isLicenseProcessingDisabled(system_exclude)
                  "
                  @click="del_system_exclude(index)"
                  class="btn btn-warning"
                >
                  <i class="bi bi-trash"></i>
                </button>
              </div>

              <!-- 利用停止中の表示 -->
              <div
                v-if="isLicenseProcessingDisabled(system_exclude)"
                class="alert alert-warning mt-1 mb-2 py-1"
              >
                現在利用停止中のため編集できません
              </div>
            </div>
          </div>
          <div v-else>未設定</div>
          <div v-if="!change_mode">
            <button
              type="button"
              class="btn btn-light btn-outline-secondary"
              @click="add_system_exclude"
            >
              <i class="bi bi-plus"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-2">
          <p class="text-center py-1 fs-7">生存/死亡</p>
        </div>
        <div class="col-3">
          <input
            v-if="change_mode"
            :value="get_list_label(member_obj.live_flg, dead_or_live_list)"
            :class="input_class"
            :readonly="input_readonly"
          />
          <bs-select
            v-else
            :options="dead_or_live_list"
            :nullOption="true"
            id="SexType"
            v-model="member_obj.live_flg"
          ></bs-select>
          <!-- {{ dev_msg('変更者をノートに登録できるように') }} -->
        </div>
      </div>

      <div class="my-4" v-if="parent_frm_disp">
        <div class="accordion" id="accordionParentInfo">
          <div class="accordion-item">
            <h2 class="accordion-header" id="headingParentInfo">
              <button
                class="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseParentInfo"
                aria-expanded="false"
                aria-controls="collapseParentInfo"
              >
                親権者情報
              </button>
            </h2>
            <div
              id="collapseParentInfo"
              class="accordion-collapse collapse"
              aria-labelledby="headingParentInfo"
              data-bs-parent="#accordionParentInfo"
            >
              <div class="accordion-body">
                <div
                  class="container"
                  v-for="(parent, parent_index) in member_obj.member_parent"
                  :key="parent"
                >
                  <div class="row mb-3">
                    <div class="col-2">
                      <p class="text-center py-1 fs-7">親権者名</p>
                    </div>
                    <div class="col-3">
                      <input
                        type="text"
                        :class="input_class"
                        id="Name_1"
                        placeholder="姓"
                        v-model="parent.name_1"
                        :readonly="input_readonly"
                      />
                    </div>
                    <div class="col-3">
                      <input
                        type="text"
                        :class="input_class"
                        id="Name_2"
                        placeholder="名"
                        v-model="parent.name_2"
                        :readonly="input_readonly"
                      />
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-2">
                      <p class="text-center py-1 fs-7">親権者名 カナ</p>
                    </div>
                    <div class="col-3">
                      <input
                        type="text"
                        :class="input_class"
                        id="Yomi_1"
                        placeholder="セイ"
                        v-model="parent.yomi_1"
                        :readonly="input_readonly"
                      />
                    </div>
                    <div class="col-3">
                      <input
                        type="text"
                        :class="input_class"
                        id="Yomi_1"
                        placeholder="メイ"
                        v-model="parent.yomi_2"
                        :readonly="input_readonly"
                      />
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-2">
                      <p class="text-center py-1 fs-7">親権者 性別</p>
                    </div>
                    <div class="col-3">
                      <input
                        v-if="change_mode"
                        type="text"
                        :value="get_list_label(parent.sex_type, sex_type_list)"
                        :class="input_class"
                        :readonly="input_readonly"
                      />
                      <bs-select
                        v-else
                        :options="sex_type_list"
                        :nullOption="false"
                        v-model="parent.sex_type"
                      ></bs-select>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-2">
                      <p class="text-center py-1 fs-7">親権者 生年月日</p>
                    </div>
                    <div class="col-3">
                      <input
                        v-if="change_mode"
                        type="text"
                        :class="input_class"
                        id="BirthDate"
                        placeholder="生年月日"
                        v-model="parent.birth_date"
                        :readonly="input_readonly_f"
                      />
                      <input
                        v-else
                        type="date"
                        :class="input_class"
                        id="BirthDate"
                        placeholder="生年月日"
                        v-model="parent.birth_date"
                        :readonly="input_readonly_f"
                      />
                    </div>
                    <div class="col-3">
                      <input
                        type="text"
                        :class="input_class"
                        placeholder="生年月日"
                        :value="get_wareki(parent.birth_date)"
                        :readonly="input_readonly_f"
                      />
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-2">
                      <p class="text-center py-1 fs-7">親権者 確認書類</p>
                    </div>
                    <div class="col-3">
                      <input
                        v-if="change_mode"
                        type="text"
                        :value="
                          get_list_label(
                            parent.identify_type,
                            member_document_list
                          )
                        "
                        :class="input_class"
                        :readonly="input_readonly"
                      />
                      <bs-select
                        v-else
                        :options="member_document_list"
                        :nullOption="true"
                        v-model="parent.identify_type"
                      ></bs-select>
                    </div>
                    <div class="col-4">
                      <div class="input-group">
                        <span class="input-group-text" v-if="parent.identify_sw"
                          >承認済</span
                        >
                        <button
                          @click="set_parent_identify(parent_index)"
                          type="button"
                          class="btn btn-light btn-outline-secondary"
                          v-else-if="
                            superuser_sw &&
                            !change_mode &&
                            !parent.identify_sw &&
                            parent.identify_manage_id == 0
                          "
                        >
                          承認する
                        </button>
                        <span class="input-group-text" v-else> 確認日</span>
                        <input
                          type="date"
                          :class="input_class"
                          placeholder=""
                          v-model="parent.identify_date_date"
                          disabled="true"
                        />
                        <button
                          @click="clear_parent_identify(parent_index)"
                          type="button"
                          class="btn btn-light btn-outline-secondary"
                          v-if="
                            superuser_sw &&
                            !parent.identify_sw &&
                            parent.identify_manage_id != 0
                          "
                        >
                          解除
                        </button>
                      </div>
                    </div>
                    <div class="col-3">
                      <div class="input-group">
                        <span class="input-group-text">確認者</span>
                        <input
                          type="text"
                          :class="input_class"
                          placeholder=""
                          v-model="parent.identify_manage_label"
                          disabled="true"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-2">
                      <p class="text-center py-1 fs-8">
                        親権者 MFJ ライセンスNo.
                      </p>
                    </div>
                    <div class="col-3">
                      <input
                        type="text"
                        :class="input_class"
                        id="BirthDate"
                        placeholder="親権者 MFJ ライセンスNo"
                        v-model="parent.license_no"
                        :readonly="input_readonly"
                      />
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-2">
                      <p class="text-center py-1 fs-7">親権者写真</p>
                    </div>
                    <div class="col-3">
                      <div
                        class="w-100"
                        v-if="typeof get_assets(150, 0) === 'object'"
                      >
                        <img
                          :src="(get_assets(150, 0) || {}).path"
                          class="w-100"
                        />
                      </div>
                    </div>
                    <div class="col-6" v-if="!change_mode">
                      <input
                        type="file"
                        :class="input_class"
                        id="file_up_input_110"
                        @change="selectedFile($event, 150)"
                      />
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-2">
                      <p class="text-center py-1 fs-7">競技参加承諾書</p>
                    </div>
                    <div class="col-4">
                      <div class="input-group">
                        <span
                          class="input-group-text"
                          v-if="parent.permission_sw"
                          >承認済</span
                        >
                        <button
                          @click="set_parent_permission(parent_index)"
                          type="button"
                          class="btn btn-light btn-outline-secondary"
                          v-else-if="
                            superuser_sw &&
                            !parent.permission_sw &&
                            parent.permission_manage_id == 0
                          "
                        >
                          承認する
                        </button>
                        <input
                          type="date"
                          :class="input_class"
                          placeholder=""
                          v-model="parent.permission_date_date"
                          disabled="true"
                        />
                        <button
                          @click="clear_parent_permission(parent_index)"
                          type="button"
                          class="btn btn-light btn-outline-secondary"
                          v-if="
                            superuser_sw &&
                            !parent.permission_sw &&
                            parent.permission_manage_id != 0
                          "
                        >
                          解除
                        </button>
                      </div>
                    </div>
                    <div class="col-4">
                      <div class="input-group">
                        <span class="input-group-text">承認者</span>
                        <input
                          type="text"
                          :class="input_class"
                          placeholder=""
                          v-model="parent.permission_manage_label"
                          disabled="true"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row mb-1 pb-1 border-bottom">
        <div class="col-2">
          <p class="fs-6 mb-0 pb-0">その他</p>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-2">
          <p class="text-center py-1 fs-7">対応メモ</p>
          <div v-if="!change_mode">
            <button
              type="button"
              class="btn btn-light btn-outline-secondary"
              @click="add_note"
            >
              <i class="bi bi-plus"></i>
            </button>
          </div>
        </div>
        <div class="col-10">
          <table class="table">
            <thead>
              <tr>
                <th style="width: 20%">日時</th>
                <th style="width: auto">メモ</th>
                <th style="width: 20%">記入者</th>
                <th style="width: 10%" v-if="!change_mode"></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(note, note_index) in member_obj.member_note"
                :key="note_index"
              >
                <td>
                  <input
                    type="date"
                    v-model="note.set_date"
                    class="form-control form-control-sm"
                    :disabled="note.id > 0 ? 'disabled' : false"
                  />
                </td>
                <td>
                  <textarea
                    class="form-control form-control-sm"
                    v-model="note.body"
                    :disabled="
                      note.manage_id != $store.state.auth.userId
                        ? 'disabled'
                        : false
                    "
                  ></textarea>
                </td>
                <td>
                  <input
                    type="text"
                    v-model="note.manage_label"
                    class="form-control form-control-sm"
                    disabled="disabled"
                  />
                </td>
                <td v-if="!change_mode">
                  <button
                    type="button"
                    class="btn btn-warning btn-sm"
                    @click="del_note(note_index)"
                  >
                    <i class="bi bi-trash"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="mb-5"></div>
    <div
      class="position-sticky bottom-0 bg-light pt-3 pb-2 px-2 border rounded-1"
    >
      <div class="row">
        <div class="col-12 col-sm-4 mb-2">
          <button
            type="submit"
            v-if="change_mode"
            @click="back"
            class="btn btn-light btn-outline-secondary"
          >
            戻る
          </button>
          <button
            type="submit"
            v-else-if="not_add"
            @click="toggle_change_mode"
            class="btn btn-light btn-outline-secondary"
          >
            照会画面へ戻る
          </button>
          <button
            type="submit"
            v-else-if="!not_add"
            @click="back"
            class="btn btn-light btn-outline-secondary"
          >
            戻る
          </button>
        </div>
        <div
          class="col-12 col-sm-4 mb-2 text-center"
          v-if="chk_relation_type_editable('/member/data')"
        >
          <bs-button
            v-if="change_mode"
            :btnClass="'btn-primary'"
            @to_click_event="toggle_change_mode"
            >編集へ</bs-button
          >
          <bs-button
            v-else
            :btnClass="'btn-primary'"
            @to_click_event="update_member"
            >{{ btnLabel }}</bs-button
          >
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.fs-6 {
  font-size: 1.15rem !important;
}
.fs-7 {
  font-size: 1rem !important;
}
.fs-8 {
  font-size: 0.9rem !important;
}
.input-group > .form-control-plaintext {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
  padding: 0.375rem;
  border-bottom: solid 1px #999;
}
.form-control-plaintext {
  border-bottom: solid 1px #999;
}
</style>
<script>
import { mapState } from 'vuex'
import BsPageTitle from '../../molecules/BsPageTitle.vue'
import BsMsgAlert from '../../atoms/BsMsgAlert.vue'
import BsSelect from '../../atoms/BsSelect.vue'
// import BsCheckBox from '../../atoms/BsCheckBox.vue'
import config from '../../../const'
import common from '../../../common/common'
import BsButton from '../../atoms/BsButton.vue'

export default {
  name: 'MemberDetailView',
  data: function () {
    return {
      superuser_sw: this.$store.state.auth.userId == 1 ? true : false,
      targetid: this.$route.params.id,
      change_mode: true,
      change_mode_0: true,
      fromParentTitle: '',
      fromParentBtn: '',
      alertMessage: '',
      alertClass: 'alert-info',
      btnLabel: '',
      member_obj: {},
      member_error_obj: {},
      application_obj: [],
      pref_obj: [],
      request_type_cd_obj: [],
      identify_type_cd_obj: [],
      exclude_cd_obj: [],
      dead_or_live_obj: [],
      member_assets_cd_obj: [],
      member_document_cd_obj: [],
      continue_app_type_obj: [],
      continue_data_save_type_obj: [],
      affiliation_type_obj: [],
      belong_club_status_obj: [],
      insurance_type_obj: [],

      application_check_type_obj: [],
      application_type_obj: [],
      application_type_group_obj: [],

      add_license_frm_obj: {
        id: 0,
        m_id: this.$route.params.id,
        fixed: 0,
        payment_flg: 0,
        license_class: '',
        license_event_cd: '',
        license_cd: 0,
        license_year: '',
        license_term_cd: '',
        license_term_start_date: '',
        license_term_end_date: '',
        license_to_id: '',
        issue_date: ''
      },
      add_license_obj: [],

      add_insurance_frm_obj: {
        id: 0,
        m_id: this.$route.params.id,
        insurance_type: 0,
        sports_year: 0,
        start_date: '',
        end_date: ''
      },
      add_insurance_obj: [],

      license_type_obj: [],
      license_class_obj: [],
      license_category_obj: [],
      event_cd_obj: [],
      license_cd_obj: [],
      personal_type_obj: [],
      circuit_obj: [],
      tab_active: 'user',
      pass_chg_sw: false,
      login_pass_input: '',
      pass_chg_confirm: '',

      // subsub_category_obj: [],
      // require_list: config.REQUIRE_TYPE_LIST,
      profile_column: {
        id: 0,
        postal_cd: '',
        pref_cd: '',
        address_1: '',
        address_2: '',
        address_3: '',
        tel_1: '',
        tel_2: ''
        // mail_1: '',
        // mail_2: '',
        // mail_flg: ''
      },
      mail_1: '',
      mail_2: '',
      mail_flg: '',
      insurance_visible_count: 5,
      insurance_visible_sw: false,
      insurance_column: {
        id: 0,
        insurance_type: '',
        sports_year: '',
        start_date: '',
        end_date: ''
      },
      circuit_license_column: {
        id: 0,
        circuit_id: '',
        circuit_license_no: ''
      },
      belong_club_column: {
        id: 0,
        group_id: ''
      },
      system_exclude_column: {
        id: 0,
        exclude_cd: '',
        start_date: '',
        start_date_date: '',
        end_date: '',
        end_date_date: '',
        note: '',
        manage_id: this.$store.state.auth.userId,
        manage_label: this.$store.state.auth.label
      },
      member_parent_column: {
        id: 0,
        license_no: '',
        name_1: '',
        name_2: '',
        name_3: '',
        yomi_1: '',
        yomi_2: '',
        yomi_3: '',
        birth_date: '',
        sex_type: '',
        identify_type: '',
        identify_manage_id: '',
        identify_date: '',
        application_date: '',
        permission_date: '',
        application_date_date: '',
        permission_date_date: '',
        identify_sw: false,
        identify_manage_label: '',
        permission_manage_id: '',
        permission_manage_label: '',
        permission_manage_sw: false
      },
      member_note_column: {
        id: 0,
        manage_id: '',
        manage_label: '',
        set_date: '',
        body: ''
      },
      member_assets_column: {
        id: 0,
        type: '',
        path: ''
      },
      member_license_column: {
        id: 0,
        license_cd: '',
        license_year: '',
        license_to_id: '',
        issue_date: ''
      },
      oParam: [
        'profile',
        'insurance',
        'circuit_license',
        'belong_club',
        'system_exclude',
        'member_parent'
        // 'member_note',
        // 'member_assets',
        // 'member_license'
      ],
      sec_cd_list: [
        {
          key: 0,
          label: '--'
        },
        {
          key: 1,
          label: '管理ログイン設定'
        }
      ],
      insurance_fix_list: [
        {
          key: 1,
          label: '有効'
        },
        {
          key: 0,
          label: '無効'
        }
      ],
      license_stat_list: [
        {
          key: 0,
          label: '保留'
        },
        {
          key: 1,
          label: '有効'
        },
        {
          key: 9,
          label: '削除'
        }
      ],
      fix_fin_list: [
        {
          key: 0,
          label: '未'
        },
        {
          key: 1,
          label: '済'
        }
      ],
      payment_fin_list: [
        {
          key: 0,
          label: '未払'
        },
        {
          key: 1,
          label: '支払済'
        }
      ],
      license_no_stock_obj: [],
      // entry
      entry_type: 'result', //or yakuin
      result_year: common.getNowYear(),
      yakuin_year: common.getNowYear(),

      non_first_search_e: true,
      non_first_search_y: true,

      yakuin_license: [
        {
          key: 'road_race_level_3',
          label: 'ロードレース競技役員3級'
        },
        {
          key: 'road_race_level_2',
          label: 'ロードレース競技役員2級'
        },
        {
          key: 'road_race_level_1',
          label: 'ロードレース競技役員1級'
        },
        {
          key: 'motor_cross_level_3',
          label: 'モトクロス競技役員3級'
        },
        {
          key: 'motor_cross_level_2',
          label: 'モトクロス競技役員2級'
        },
        {
          key: 'motor_cross_level_1',
          label: 'モトクロス競技役員1級'
        },
        {
          key: 'trial_level_3',
          label: 'トライアル競技役員3級'
        },
        {
          key: 'trial_level_2',
          label: 'トライアル競技役員2級'
        },
        {
          key: 'trial_level_1',
          label: 'トライアル競技役員1級'
        },
        {
          key: 'snowmobile_level_3',
          label: 'スノーモビル競技役員3級'
        },
        {
          key: 'snowmobile_level_2',
          label: 'スノーモビル競技役員2級'
        },
        {
          key: 'snowmobile_level_1',
          label: 'スノーモビル競技役員1級'
        },
        {
          key: 'other_level_3',
          label: 'その他競技役員3級'
        },
        {
          key: 'other_level_2',
          label: 'その他競技役員2級'
        },
        {
          key: 'other_level_1',
          label: 'その他競技役員1級'
        }
      ],
      officer_position: [
        { key: 0, label: '審査委員' },
        { key: 1, label: '競技監督' },
        { key: 2, label: '車検' },
        { key: 3, label: '計時' },
        { key: 4, label: '進行' },
        { key: 5, label: '保安' },
        { key: 6, label: '救護' },
        { key: 7, label: '管制' },
        { key: 8, label: '審判' },
        { key: 9, label: 'コース' },
        { key: 10, label: 'セクション審判' },
        { key: 11, label: '事務局' }
      ],
      officer_seifuku: [
        { key: 1, label: '副' },
        { key: 0, label: '長' },
        { key: 2, label: '' },
        { key: 'NULL', label: '' },
        { key: '', label: '' }
      ],

      result_obj: [],
      yakuin_obj: []
    }
  },
  components: {
    BsPageTitle,
    BsSelect,
    BsMsgAlert,
    BsButton
  },
  methods: {
    async loadYakuinObj() {
      this.result_obj = []
      const params = {}
      params.licenseNo = this.member_obj?.license_no
      console.log('params', params)
      await this.basicPosts_S(
        config.BASE_API_URL + '/member_yakuin/lists',
        params
      )
        .then(async response => {
          console.log('loadResultObj response', response)
          this.yakuin_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.yakuin_obj = []
        })
        .finally(async () => {
          this.non_first_search_y = false
          this.$forceUpdate()
        })
    },
    async loadResultObj() {
      this.result_obj = []
      const params = {}
      params.targetYear = this.result_year
      params.licenseNo = this.member_obj?.license_no
      console.log('params', params)
      await this.basicPosts_S(
        config.BASE_API_URL + '/member_result/lists',
        params
      )
        .then(async response => {
          console.log('loadResultObj response', response)
          this.result_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.result_obj = []
        })
        .finally(async () => {
          this.non_first_search_e = false
          this.$forceUpdate()
        })
    },
    async toggleEntryType() {
      this.result_obj = []
      this.yakuin_obj = []
      if (this.entry_type == 'result') {
        this.entry_type = 'yakuin'
        await this.loadYakuinObj()
      } else {
        this.entry_type = 'result'
      }
    },

    formatPoint(value) {
      if (!value) return 0
      return parseFloat(value) % 1 === 0
        ? parseFloat(value).toFixed(0)
        : parseFloat(value).toString()
    },
    toggle_insurance_visible() {
      if (this.insurance_visible_sw) {
        this.insurance_visible_sw = false
      } else {
        this.insurance_visible_sw = true
      }
    },
    async go_application(target) {
      this.$router.push({ path: '/application/' + target + '/' })
    },
    async add_license() {
      const tmp = { ...this.add_license_frm_obj }
      const tmps = [...this.add_license_obj]
      tmps.push(tmp)
      this.add_license_obj = tmps
    },
    // ライセンスフォーム削除
    async del_member_license(target) {
      const member_tmp =
        typeof this.member_obj === 'object' ? { ...this.member_obj } : false
      const member_license_tmp =
        typeof member_tmp?.member_license === 'object'
          ? [...member_tmp.member_license]
          : []
      const target_index = member_license_tmp.findIndex(
        license => license.id == target
      )
      member_license_tmp.splice(target_index, 1)

      member_tmp.member_license = member_license_tmp
      this.member_obj = member_tmp
    },
    // ライセンス追加フォーム削除
    async del_add_license(index) {
      const tmps =
        typeof this.add_license_obj === 'object'
          ? [...this.add_license_obj]
          : []
      tmps.splice(index, 1)
      this.add_license_obj = tmps
    },
    async del_member_insurance(target) {
      const member_tmp =
        typeof this.member_obj === 'object' ? { ...this.member_obj } : false
      const insurance_tmp =
        typeof member_tmp?.insurance === 'object'
          ? [...member_tmp.insurance]
          : []
      const target_index = insurance_tmp.findIndex(
        insurance => insurance.id == target
      )
      insurance_tmp.splice(target_index, 1)

      member_tmp.insurance = insurance_tmp
      this.member_obj = member_tmp
    },
    // 保険追加フォーム
    async add_insurance() {
      const tmp = { ...this.add_insurance_frm_obj }
      const tmps = [...this.add_insurance_obj]
      tmps.push(tmp)
      this.add_insurance_obj = tmps
    },
    // 保険追加フォーム削除
    async del_add_insurance(index) {
      const tmps =
        typeof this.add_insurance_obj === 'object'
          ? [...this.add_insurance_obj]
          : []
      tmps.splice(index, 1)
      this.add_insurance_obj = tmps
    },
    async selectedFile(e, type_cd) {
      e.preventDefault()
      const files = [...e.target.files]
      // let ups = [];
      files.forEach(async file => {
        const form = new FormData()
        form.append('file', file)
        await this.basicPosts_R(
          config.BASE_API_URL + '/upload/member_assets',
          form
        )
          .then(res => {
            console.log(res)
            if (res && res.status == 200) {
              const asset_tmp = {
                id: 0,
                stat: 1,
                m_id: 0,
                type: 0,
                path: ''
              }
              const tmps =
                typeof this.member_obj.member_assets === 'object'
                  ? [...this.member_obj.member_assets]
                  : []
              const asset = tmps.find(tmp => tmp.type == type_cd)
                ? tmps.find(tmp => tmp.type == type_cd)
                : asset_tmp
              asset.m_id = this.not_add ? this.targetid : 0
              asset.type = type_cd
              asset.path = res.data.body.file_path
                ? res.data.body.file_path
                : ''

              if (tmps.find(tmp => tmp.id == asset.id)) {
                const fIndex = tmps.findIndex(tmp => tmp.id == asset.id)
                tmps[fIndex] = asset
                this.member_obj.member_assets = tmps
              } else {
                this.member_obj.member_assets = [asset].concat(tmps)
              }
            }
          })
          .catch(error => {
            console.log(error)
          })
          .finally(() => {
            document.getElementById('file_up_input_' + type_cd).value = ''
          })
      })
    },
    async add_circuit_license() {
      const tmps = { ...this.circuit_license_column }
      const circuit_license =
        typeof this.member_obj.circuit_license === 'object'
          ? this.member_obj.circuit_license
          : []
      circuit_license.push(tmps)
      this.member_obj.circuit_license = circuit_license
    },
    async add_belong_club() {
      const tmps = { ...this.belong_club_column }
      const belong_club =
        typeof this.member_obj.belong_club === 'object'
          ? this.member_obj.belong_club
          : []
      belong_club.push(tmps)
      this.member_obj.belong_club = belong_club
    },
    async add_system_exclude() {
      const tmps = { ...this.system_exclude_column }
      const system_exclude =
        typeof this.member_obj.system_exclude === 'object'
          ? this.member_obj.system_exclude
          : []
      system_exclude.push(tmps)
      this.member_obj.system_exclude = system_exclude
    },
    async del_system_exclude(index) {
      const system_exclude =
        typeof this.member_obj.system_exclude === 'object'
          ? [...this.member_obj.system_exclude]
          : []
      system_exclude.splice(index, 1)
      this.member_obj.system_exclude = system_exclude
    },
    async add_note() {
      const tmps = { ...this.member_note_column }
      tmps.set_date = common.getToday()
      tmps.manage_id = this.$store.state.auth.userId
      tmps.manage_label = this.$store.state.auth.label
      const notes =
        typeof this.member_obj.member_note === 'object'
          ? this.member_obj.member_note
          : []
      notes.push(tmps)
      this.member_obj.member_note = notes
    },

    async del_note(note_index) {
      const note_data = [...this.member_obj.member_note]
      if (note_data[note_index]) {
        note_data.splice(note_index, 1)
      }
      this.member_obj.member_note = note_data
    },
    async set_member_identify() {
      this.member_obj.identify_manage_id = this.$store.state.auth.userId
      this.member_obj.identify_date_date = common.getToday()
      this.member_obj.identify_manage_label = this.$store.state.auth.label
    },
    async clear_member_identify() {
      this.member_obj.identify_manage_id = 0
      this.member_obj.identify_date_date = ''
      this.member_obj.identify_manage_label = ''
    },
    async set_member_permission() {
      this.member_obj.permission_manage_id = this.$store.state.auth.userId
      this.member_obj.permission_date_date = common.getToday()
      this.member_obj.permission_manage_label = this.$store.state.auth.label
    },
    async clear_member_permission() {
      this.member_obj.permission_manage_id = 0
      this.member_obj.permission_date_date = ''
      this.member_obj.permission_manage_label = ''
    },
    async set_parent_identify(index) {
      this.member_obj.member_parent[index].identify_manage_id =
        this.$store.state.auth.userId
      this.member_obj.member_parent[index].identify_date_date =
        common.getToday()
      this.member_obj.member_parent[index].identify_manage_label =
        this.$store.state.auth.label
    },
    async clear_parent_identify(index) {
      this.member_obj.member_parent[index].identify_manage_id = 0
      this.member_obj.member_parent[index].identify_date_date = ''
      this.member_obj.member_parent[index].identify_manage_label = ''
    },
    async set_parent_permission(index) {
      this.member_obj.member_parent[index].permission_manage_id =
        this.$store.state.auth.userId
      this.member_obj.member_parent[index].permission_date_date =
        common.getToday()
      this.member_obj.member_parent[index].permission_manage_label =
        this.$store.state.auth.label
    },
    async clear_parent_permission(index) {
      this.member_obj.member_parent[index].permission_manage_id = 0
      this.member_obj.member_parent[index].permission_date_date = ''
      this.member_obj.member_parent[index].permission_manage_label = ''
    },
    delPreferredData(target) {
      const tmps = { ...this.member_obj }
      if (
        typeof tmps.preferred_date_data === 'object' &&
        typeof tmps.preferred_date_data[target] === 'object'
      ) {
        tmps.preferred_date_data.splice(target, 1)
      }
      this.member_obj = tmps
    },
    addPreferredData() {
      const tmps = { ...this.member_obj }
      tmps.preferred_date_data.push(this.preferred_date_column)
      this.member_obj = tmps
    },
    delStaffRelation(target) {
      const tmps = { ...this.member_obj }
      if (
        typeof tmps.staff_relation_data === 'object' &&
        typeof tmps.staff_relation_data[target] === 'object'
      ) {
        tmps.staff_relation_data.splice(target, 1)
      }
      this.member_obj = tmps
    },
    addStaffRelation() {
      const tmps = { ...this.member_obj }
      tmps.staff_relation_data.push(this.staff_relation_column)
      this.member_obj = tmps
    },
    async loadSexType() {
      // console.log('tag');
      return this.$store
        .dispatch('fetchBasicLists', { data: {}, target: 'sex_type' })
        .catch(err => Promise.reject(err))
        .then(response => {
          console.log('loadSexType', response)
        })
        .finally(() => {})
    },
    async loadLicenseCdList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(config.BASE_API_URL + '/license_cd/lists', params)
        .then(async response => {
          console.log('loadLicenseCdList response', response)
          this.license_cd_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.license_cd_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadEventCdList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(
        config.BASE_API_URL + '/license_event_cd/lists',
        params
      )
        .then(async response => {
          console.log('loadEventCdList response', response)
          this.event_cd_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.event_cd_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadLicenseClassList() {
      const params = {}
      await this.basicPosts_S(
        config.BASE_API_URL + '/config/license_class',
        params
      )
        .then(async response => {
          console.log('loadLicenseClassList response', response)
          this.license_class_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.license_class_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadLicenseCategoryList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(
        config.BASE_API_URL + '/config/license_category',
        params
      )
        .then(async response => {
          console.log('loadLicenseCategoryList response', response)
          this.license_category_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.license_category_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadLicenseTypeObj() {
      const params = {}
      params['id'] = this.targetid
      await this.basicPosts_S(
        config.BASE_API_URL + '/license_type/lists',
        params
      )
        .then(async response => {
          console.log('loadLicenseCdObj', response)
          this.license_type_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.license_type_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadPrefList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(config.BASE_API_URL + '/area_pref/lists', params)
        .then(async response => {
          console.log('loadPrefList response', response)
          this.pref_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.pref_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadCircuitList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(config.BASE_API_URL + '/circuit/lists', params)
        .then(async response => {
          console.log('loadCircuitList response', response)
          this.circuit_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.circuit_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadApplicationList() {
      const params = {}
      params['stat'] = [1]
      params['m_id'] = this.targetid
      params['pagelimit'] = 10
      params['pagelimit_key'] = 10
      params['pageorder'] = 'mfj_member_application.cre_date'
      params['pagesort'] = 'DESC'
      params['pagegroup'] = 'mfj_member_application.id'

      console.log('loadApplicationList params', params)
      // this.$store.dispatch('setSearchParam', {
      //   data: params,
      //   target: 'application_list'
      // })

      try {
        const response = await this.basicPosts_S(
          config.BASE_API_URL + '/member_application/get_simple',
          params
        )

        console.log('loadApplicationList response', response)
        this.application_obj =
          response.data && response.data.body ? response.data.body : []
      } catch (err) {
        console.log(err)
        this.application_obj = []
      } finally {
        this.$forceUpdate()
      }
    },
    // ConfigObjを読み込む別メソッドとして定義
    async loadConfigObj(param) {
      try {
        const response = await this.basicPosts_S(
          config.BASE_API_URL + '/config/' + param,
          {}
        )
        this[param + '_obj'] =
          response.data && response.data.body ? response.data.body : []
      } catch (err) {
        console.log(err)
        this[param + '_obj'] = []
      } finally {
        this.$forceUpdate()
      }
    },
    async loadMemberObj() {
      const params = {}
      params['id'] = this.targetid
      // params['pagelimit'] = 1
      await this.basicPosts_S(config.BASE_API_URL + '/member/m_single', params)
        .then(async response => {
          console.log('loadMemberObj', response)
          const tmp_obj =
            response.data && response.data.body && response.data.body[0]
              ? response.data.body[0]
              : {}

          if (typeof tmp_obj === 'object') {
            // last_sports_yearの初期化を追加
            tmp_obj.last_sports_year =
              tmp_obj.last_sports_year || common.getNowYear()
            tmp_obj.live_flg_now = tmp_obj.live_flg ? tmp_obj.live_flg : 'live'
            const tmps = {}
            Object.keys(tmp_obj).forEach(tmp_key => {
              tmps[tmp_key] = typeof tmp_obj[tmp_key] === 'object' ? [] : false
            })
            this.member_error_obj = tmps

            this.oParam.forEach(param => {
              const param_key = param + '_column'
              if (
                typeof tmp_obj[param] !== 'object' ||
                tmp_obj[param] === false
              ) {
                tmp_obj[param] = []
              }
              if (
                typeof tmp_obj[param] === 'object' &&
                tmp_obj[param].length <= 0
              ) {
                if (
                  [
                    'insurance_column',
                    'circuit_license_column',
                    'belong_club_column',
                    'system_exclude_column',
                    'member_note_column'
                  ].includes(param_key) === false
                )
                  tmp_obj[param].push({ ...this[param_key] })
              } else if (param == 'profile') {
                const profile_tmp = tmp_obj[param].map(tmp => {
                  // tel_1 と tel_2 が既に文字列の場合は変更しない
                  if (typeof tmp.tel_1 === 'string') {
                    tmp.tel_1 = tmp.tel_1.replace(/[^\d-]/g, '') // 数字とハイフン以外を削除
                  } else if (Array.isArray(tmp.tel_1)) {
                    tmp.tel_1 = tmp.tel_1.join('-') // 配列の場合、文字列に変換
                  }

                  if (typeof tmp.tel_2 === 'string') {
                    tmp.tel_2 = tmp.tel_2.replace(/[^\d-]/g, '') // 数字とハイフン以外を削除
                  } else if (Array.isArray(tmp.tel_2)) {
                    tmp.tel_2 = tmp.tel_2.join('-') // 配列の場合、文字列に変換
                  }

                  return tmp
                })

                tmp_obj[param] = profile_tmp
              } else if (param == 'insurance') {
                const insurance_tmp = [...tmp_obj[param]].reverse()
                tmp_obj[param] = insurance_tmp
              }
            })
          }
          // 上書き
          this.member_obj = tmp_obj
        })
        .catch(async err => {
          console.log(err)
          this.member_obj = {}
        })
        .finally(async () => {
          if (this.targetid) await this.loadApplicationList()
          this.$forceUpdate()
        })
    },
    async loadLicenseNoStock() {
      const params = {}
      params['stat'] = [1]
      params['used_flg'] = 0
      params['pagelimit'] = 20
      await this.basicPosts_S(
        config.BASE_API_URL + '/license_no_stock/lists',
        params
      )
        .then(async response => {
          console.log('loadLicenseNoStock', response)
          this.license_no_stock_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.license_no_stock_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async toggle_change_mode() {
      if (this.change_mode) {
        this.change_mode = false
      } else {
        this.change_mode = true
        this.clearErrors()
        // データを再読み込み
        await this.loadMemberObj()
      }
    },
    clearErrors() {
      this.member_error_obj = {}
      this.alertClass = ''
      this.alertMessage = ''
    },
    async update_member() {
      const params = this.member_obj
      if (this.pass_chg_sw && this.pass_chg_confirm != this.login_pass_input) {
        alert('パスワードが一致しません')
        return true
      } else if (this.pass_chg_sw && this.pass_chg_confirm == '') {
        alert('パスワードを入力して下さい')
        return true
      } else if (
        this.pass_chg_sw &&
        this.pass_chg_confirm == this.login_pass_input
      ) {
        params.login_pass = this.login_pass_input
      }
      if (!this.pass_chg_sw) {
        delete params['login_pass']
      }
      if (!['male', 'female'].includes(params.sex_type)) {
        alert('性別を選択して下さい')
        return true
      }

      const profs = (params || {}).profile
      if (typeof profs === 'object') {
        params.profile = profs.map((prof, index) => {
          // tel_1 と tel_2 が既に文字列の場合は変更しない
          if (Array.isArray(prof.tel_1)) {
            prof.tel_1 = prof.tel_1.join('-')
          }
          if (Array.isArray(prof.tel_2)) {
            prof.tel_2 = prof.tel_2.join('-')
          }
          if (index == 0 && prof.mail_1 != params.mail_1) {
            prof.mail_1 = params.mail_1
          }
          if (index == 0 && prof.mail_2 != params.mail_2) {
            prof.mail_2 = params.mail_2
          }
          return prof
        })
      }

      // console.log(
      //   'update_member this.member_obj.member_license',
      //   this.member_obj.member_license
      // );
      const member_license = (params || {}).member_license
        ? (params || {}).member_license
        : []
      //add
      if (
        typeof this.add_license_obj === 'object' &&
        this.add_license_obj.length > 0
      ) {
        this.add_license_obj.map(license => {
          member_license.push(license)
        })
      }
      if (typeof member_license === 'object') {
        params.member_license = member_license.map(license => {
          // tel_1 と tel_2 が既に文字列の場合は変更しない
          return license
        })
      }

      const member_insurance = (params || {}).insurance
        ? (params || {}).insurance
        : []
      //add
      if (
        typeof this.add_insurance_obj === 'object' &&
        this.add_insurance_obj.length > 0
      ) {
        this.add_insurance_obj.map(insurance => {
          member_insurance.push(insurance)
        })
      }
      if (typeof member_insurance === 'object') {
        params.insurance = member_insurance.map(insurance => {
          // tel_1 と tel_2 が既に文字列の場合は変更しない
          return insurance
        })
      }
      this.add_license_obj = []
      this.add_insurance_obj = []

      await this.update(params)
    },
    async update(params) {
      if (!(this.get_license_no_stock || {}).license_no) {
        alert('ライセンスNoが不正です')
        return false
      }
      params.license_no = this.get_license_no_stock.license_no

      console.log('component methods', this.member_obj)

      const post_url = this.not_add
        ? config.BASE_API_URL + '/member/edit/' + this.targetid
        : config.BASE_API_URL + '/member/add'

      let result = true
      await this.basicPosts_I(post_url, params)
        .then(async response => {
          console.log('update member response', response)
          if (
            typeof response === 'object' &&
            response.data &&
            response.data &&
            response.data.status == '200'
          ) {
            this.alertMessage = this.btnLabel + 'しました'
            this.alertClass = 'alert-success'
            this.targetid = response.data.body[0].id
          } else if (
            typeof response === 'object' &&
            typeof response.data === 'object' &&
            response.data.status == '500'
          ) {
            console.log(
              'error update status 500',
              response.data.alert.error_obj
            )
            this.alertMessage = this.btnLabel + 'できませんでした'
            this.alertClass = 'alert-danger'
            result = false
            if (typeof response.data.alert.error_obj === 'object') {
              const tmp_error = { ...this.member_error_obj }
              Object.keys(response.data.alert.error_obj).forEach(key => {
                tmp_error[key] = response.data.alert.error_obj[key]
              })
              this.member_error_obj = tmp_error
            }
          } else {
            this.alertMessage = this.btnLabel + 'できませんでした'
            this.alertClass = 'alert-danger'
            result = false
          }
        })
        .catch(err => {
          console.log(err)
          this.alertMessage = this.btnLabel + 'できませんでした'
          this.alertClass = 'alert-danger'
        })
        .finally(async () => {
          if (result) await this.loadMemberObj()
          this.$forceUpdate()
          alert(this.alertMessage)
        })
    },
    back() {
      this.$router.go(-1)
    },
    tab_switch_action(tab) {
      this.tab_active = tab
    },
    async get_address(postal_cd, index) {
      const profile = this.member_obj.profile[index]
      await this.basicGets_O(
        'https://zipcloud.ibsnet.co.jp/api/search?zipcode=' + postal_cd
      )
        .then(res => {
          if (
            typeof res === 'object' &&
            typeof res.status === 'number' &&
            res.status == 200 &&
            typeof res.data === 'object' &&
            typeof res.data.results === 'object' &&
            typeof res.data.results[0] === 'object'
          ) {
            profile.pref_cd = res.data.results[0].prefcode
            // parseInt(res.data.results[0].prefcode) < 10
            //   ? '0' + res.data.results[0].prefcode
            //   : res.data.results[0].prefcode
            profile.address_1 =
              res.data.results[0].address2 + res.data.results[0].address3
            profile.address_2 = ''
            this.member_obj.profile[index] = profile
          } else {
            alert('住所データがありません')
          }
        })
        .catch(error => {
          console.log(error)
          alert('住所データがありません.')
        })
        .finally(() => {
          this.$forceUpdate()
        })
    },

    // 利用停止・移籍による制限をチェックする関数
    isLicenseProcessingDisabled(system_exclude) {
      if (!system_exclude) return false
      return false
      // const excludeCode = String(system_exclude.exclude_cd)
      // // 利用停止(10)または移籍(30)の場合のみ編集不可
      // return excludeCode === '10' || excludeCode === '30'
    },

    // 会員全体の利用停止判定（その他の項目用）
    isAllLicenseProcessingDisabled() {
      if (!this.member_obj?.system_exclude) return false

      return this.member_obj.system_exclude.some(exclude => {
        const excludeCode = String(exclude.exclude_cd)
        return excludeCode === '10' || excludeCode === '30'
      })
    }
  },
  computed: {
    year_list: function () {
      let min = 2015
      const max = common.getNowYear()
      const tmps = []
      for (let i = min; i <= max + 1; i++) {
        tmps.push({
          key: i,
          label: i + '年度'
        })
      }
      return tmps
    },
    insurance_year_sort: function () {
      const insurance = this.member_obj.insurance
      return insurance
        ? insurance.sort((a, b) => {
            if (parseInt(a.sports_year) > parseInt(b.sports_year)) {
              return -1
            } else {
              return 1
            }
          })
        : []
    },
    yakuin_license_list: function () {
      return this.yakuin_license.filter(license => {
        if (
          Array.isArray(this.yakuin_obj) &&
          this.yakuin_obj.length > 0 &&
          this.yakuin_obj.find(
            yakuin => yakuin[license.key] && parseInt(yakuin[license.key]) > 0
          )
        ) {
          return true
        }
        return false
      })
    },
    chk_entry_type: function () {
      const entry_type = this.entry_type
      return function (type) {
        if (entry_type == type) return true
        return false
      }
    },
    get_entry_type_btn_active: function () {
      const chk = this.chk_entry_type
      return function (type) {
        if (chk(type)) {
          return 'btn-primary'
        }
        return 'btn-light'
      }
    },
    get_result_series_sum_point: function () {
      const get_data = this.get_result_filter_series
      return function (series_cd, class_id) {
        let point = 0
        if (Array.isArray(get_data(series_cd, class_id))) {
          get_data(series_cd, class_id).map(data => {
            // if (parseFloat(data.mfj_result_levelup_point) > 0) {
            //   point += parseFloat(data.mfj_result_levelup_point)
            if (parseFloat(data.mfj_result_normal_point) > 0) {
              point += parseFloat(data.mfj_result_normal_point)
            }
          })
        }
        return point
      }
    },
    get_result_filter_series: function () {
      const results = this.result_obj
      return function (series_cd, class_id) {
        if (Array.isArray(results) && results.length > 0) {
          return [
            ...results.filter(
              result =>
                result.race_series_cd == series_cd &&
                result.mfj_class_data_id == class_id
            )
          ]
        }
        return []
      }
    },
    get_result_event_name_heatchk: function () {
      const obj_list = this.result_obj
      return function (result) {
        if (
          Array.isArray(obj_list) &&
          obj_list.find(
            obj => obj.mfj_event_main_data_id == result.mfj_event_main_data_id
          ) &&
          obj_list.filter(
            obj => obj.mfj_event_main_data_id == result.mfj_event_main_data_id
          ).length > 1
        ) {
          return (
            result.mfj_event_sub_data_event_name +
            ' heat ' +
            result.mfj_result_heat
          )
        }
        return result.mfj_event_sub_data_event_name
      }
    },
    get_result_series_class_data: function () {
      // const series_data = this.get_result_series_data
      const results = this.result_obj
      return function (series_cd) {
        const tmps = []
        if (Array.isArray(results) && results.length > 0) {
          results.map(result => {
            if (
              result.race_series_cd == series_cd &&
              !tmps.find(tmp => tmp.class_id == result.mfj_class_data_id)
            ) {
              tmps.push({
                class_id: result.mfj_class_data_id,
                label: result.mfj_class_data_name,
                event_cd: result.event_cd
              })
            }
          })
        }
        return tmps
      }
    },
    get_result_series_data: function () {
      const tmps = []
      if (Array.isArray(this.result_obj) && this.result_obj.length > 0) {
        this.result_obj.map(result => {
          if (!tmps.find(tmp => tmp.series_cd == result.race_series_cd)) {
            tmps.push({
              series_cd: result.race_series_cd,
              label: result.race_series_name
            })
          }
        })
      }
      return tmps
    },
    get_yakuin_sum_point: function () {
      const get_data = this.get_yakuin_filter_license
      return function (column) {
        let point = 0
        if (Array.isArray(get_data(column))) {
          get_data(column).map(data => {
            if (parseFloat(data.mfj_officer_point) > 0) {
              point += parseFloat(data.mfj_officer_point)
            }
          })
        }
        return point
      }
    },
    get_yakuin_filter_license: function () {
      const yakuin_data = this.yakuin_obj
      return function (column) {
        return yakuin_data
          .filter(yakuin => {
            if (yakuin[column] && parseInt(yakuin[column]) > 0) {
              console.log('column', column, yakuin[column], yakuin)
              return true
            }
            return false
          })
          .sort((a, b) => {
            return (
              new Date(a.mfj_event_main_data_event_date_start) -
              new Date(b.mfj_event_main_data_event_date_start)
            )
          })
      }
    },
    insurance_visible_tr: function () {
      const visible_sw = this.insurance_visible_sw
      const insurance_visible_count = this.insurance_visible_count
      return function (index) {
        if (visible_sw == true) {
          return true
        } else if (parseInt(index) < insurance_visible_count) {
          return true
        }
        return false
      }
    },
    chk_app_1000_circuit_data_valid: function () {
      return this.get_app_1000_circuit_data_valid ? true : false
    },
    get_app_1000_circuit_data_valid: function () {
      if (
        Array.isArray(this.application_obj) &&
        this.application_obj.find(
          app =>
            app.stat == 1 &&
            (app.application_type == 1000 || app.application_type == 1300)
        ) &&
        this.application_obj.find(
          app =>
            app.stat == 1 &&
            (app.application_type == 1000 || app.application_type == 1300) &&
            Array.isArray(app.draft_orders) &&
            app.draft_orders.find(
              order => parseInt(order.join_3hour_circuit_id) > 0
            )
        )
      ) {
        const tmps = []
        this.application_obj
          .filter(
            app =>
              app.stat == 1 &&
              (app.application_type == 1000 || app.application_type == 1300) &&
              Array.isArray(app.draft_orders) &&
              app.draft_orders.find(
                order => parseInt(order.join_3hour_circuit_id) > 0
              )
          )
          .map(app => {
            if (Array.isArray(app.draft_orders)) {
              app.draft_orders
                .filter(
                  draft_order => parseInt(draft_order.join_3hour_circuit_id) > 0
                )
                .map(draft_order => {
                  tmps.push(draft_order)
                })
            }
          })
        return tmps
      }
      return false
    },
    get_license_no_stock: function () {
      const tmps = this.license_no_stock_obj.filter(
        stock => stock.used_flg == 0
      )
      return typeof tmps === 'object' && tmps[0] ? tmps[0] : false
    },
    get_license_no_stock_input: function () {
      const tmps = this.license_no_stock_obj.filter(
        stock => stock.license_no == this.request_license_no
      )
      return typeof tmps === 'object' && tmps[0] ? tmps[0] : false
    },
    license_no_stock_list: function () {
      return this.license_no_stock_obj
    },
    ...mapState({
      sex_type_list: state => state.apidata.sex_type
    }),
    parent_frm_disp: function () {
      return (
        this.member_obj &&
        this.member_obj.member_parent &&
        Object.keys(this.member_obj.member_parent).name_1 !== '' &&
        Object.keys(this.member_obj.member_parent).name_2 !== ''
      )
    },
    get_wareki: function () {
      const regex1 = /^[0-9]{4}[/-](0[1-9]|1[0-2])[/-](0[1-9]|[12][0-9]|3[01])/

      return function (birth_date) {
        if (regex1.test(birth_date)) {
          console.log('get_wareki', regex1.test(birth_date), birth_date)
          return new Date(birth_date).toLocaleDateString(
            'ja-JP-u-ca-japanese',
            {
              dateStyle: 'long'
            }
          )
        }
        return birth_date
      }
    },
    chk_parent_form: function () {
      if (
        this.calc_age <= 18 &&
        typeof this.member_obj === 'object' &&
        typeof this.member_obj.member_license === 'object'
        // && typeof this.member_obj.member_license.find()
      ) {
        return true
      }
      return false
    },
    input_class: function () {
      if (this.change_mode) {
        return 'form-control-plaintext'
      } else {
        return 'form-control'
      }
    },
    input_readonly: function () {
      if (this.change_mode) {
        return true
      } else {
        return false
      }
    },
    input_class_0: function () {
      if (this.change_mode_0) {
        return 'form-control-plaintext'
      } else {
        return 'form-control'
      }
    },
    input_readonly_0: function () {
      if (this.change_mode_0) {
        return true
      } else {
        return false
      }
    },
    input_class_f: function () {
      if (this.change_mode) {
        return 'form-control-plaintext'
      } else {
        return 'form-control-plaintext'
      }
    },
    input_readonly_f: function () {
      if (this.change_mode) {
        return true
      } else {
        return false
      }
    },
    get_list_label: function () {
      return function (key, lists) {
        if (key === '0' && !lists.find(list => parseInt(list.key) === 0))
          return '未選択'
        if (
          typeof lists === 'object' &&
          typeof lists.find(list => list.key == key) === 'object'
        ) {
          return lists.find(list => list.key == key).label
        }
        return key
      }
    },
    get_pref_label: function () {
      const pref_list = this.pref_list
      return function (key) {
        if (typeof pref_list.find(pref => pref.key == key) === 'object') {
          return pref_list.find(pref => pref.key == key).label
        }
        return key
      }
    },
    get_request_cd_label: function () {
      const lists = this.request_type_list
      return function (key) {
        if (typeof lists.find(list => list.key == key) === 'object') {
          return lists.find(list => list.key == key).label
        }
        return key
      }
    },
    get_sex_type_label: function () {
      const sex_type_list = this.sex_type_list
      return function (key) {
        if (
          typeof sex_type_list.find(sex_type => sex_type.key == key) ===
          'object'
        ) {
          return sex_type_list.find(sex_type => sex_type.key == key).label
        }
        return key
      }
    },
    get_assets: function () {
      const member_obj = this.member_obj
      return function (type_cd, sort_key) {
        if (
          typeof member_obj === 'object' &&
          typeof member_obj.member_assets === 'object' &&
          member_obj.member_assets.find(asset => asset.type == type_cd) !==
            false &&
          typeof member_obj.member_assets.filter(
            asset => asset.type == type_cd
          ) === 'object' &&
          typeof member_obj.member_assets.filter(
            asset => asset.type == type_cd
          )[sort_key] === 'object'
        ) {
          return member_obj.member_assets.filter(
            asset => asset.type == type_cd
          )[sort_key]
        }
        return {}
      }
    },
    chk_input_class: function () {
      const chk_func = this.chk_error
      return function (error_key, form) {
        if (form == 'input') {
          if (chk_func(error_key)) {
            return 'form-control is-invalid'
          } else {
            return 'form-control'
          }
        }
        return 'form-control'
      }
    },
    get_error: function () {
      const error_obj = this.member_error_obj
      return function (error_key) {
        const params =
          error_key.indexOf('.') > -1
            ? error_key.split('.')
            : [].concat(error_key)
        if (typeof error_obj === 'object' && typeof params === 'object') {
          if (
            params.length == 2 &&
            typeof error_obj[params[0]] === 'object' &&
            typeof error_obj[params[0]][params[1]] === 'string'
          ) {
            return error_obj[params[0]][params[1]]
          } else if (
            params.length == 1 &&
            typeof error_obj[params[0]] === 'string'
          ) {
            return error_obj[params[0]]
          }
        }
        return false
      }
    },
    chk_error: function () {
      const get_func = this.get_error
      return function (error_key) {
        if (get_func(error_key)) {
          return true
        }
        return false
      }
    },
    get_error_msg: function () {
      const chk_func = this.chk_error
      const get_func = this.get_error
      return function (error_key) {
        if (chk_func(error_key)) {
          return get_func(error_key)
        }
        return ''
      }
    },
    // get_license_term_oldest_year: function () {
    //   const member_license = [...this.member_obj.member_license]
    // },
    // get_license_term_newest_year: function () {},
    get_year_list_have_license: function () {
      const tmps = []
      if (Array.isArray(this.member_obj?.member_license)) {
        this.member_obj?.member_license?.map(license => {
          if (!tmps.includes(parseInt(license.license_year))) {
            tmps.push(parseInt(license.license_year))
          }
        })
      }
      return tmps.sort((a, b) => (a > b ? -1 : 1))
    },
    license_filter_sort: function () {
      const member_license =
        typeof this.member_obj?.member_license === 'object'
          ? [...this.member_obj.member_license]
          : false
      return function (license_class, license_year) {
        if (typeof member_license === 'object') {
          return (
            member_license
              .filter(
                license =>
                  parseInt(license.license_class) == parseInt(license_class) &&
                  parseInt(license.license_year) == parseInt(license_year)
              )
              // .map(license => {
              //   license.keysort = license.license_year
              //   return license
              // })
              .sort((a, b) => {
                if (parseInt(a.license_cd) > parseInt(b.license_cd)) {
                  return -1
                  // } else if (parseInt(a.keysort) > parseInt(b.keysort)) {
                  //   return -1
                } else if (
                  parseInt(a.license_year) > parseInt(b.license_year)
                ) {
                  return -1
                } else {
                  return 1
                }
              })
          )
        }
        return false
      }
    },

    get_member_license_filter_year: function () {
      const member_license =
        typeof this.member_obj?.member_license === 'object'
          ? [...this.member_obj.member_license]
          : false
      return function (year) {
        if (typeof member_license === 'object') {
          return member_license.filter(
            license => parseInt(license.license_year) == parseInt(year)
          )
        }
        return false
      }
    },
    get_member_license_filter_year_class: function () {
      const get_func = this.get_member_license_filter_year
      return function (year, class_cd) {
        const get_data = get_func(year)
        if (typeof get_data === 'object') {
          return get_data.filter(
            license => parseInt(license.license_class) == parseInt(class_cd)
          )
        }
        return false
      }
    },
    chk_member_license_filter_year_class_only_term: function () {
      const get_func = this.get_member_license_filter_year_class
      const get_func2 = this.get_member_license_filter_year_class_term
      return function (year, class_cd, term_cd) {
        const get_data = get_func(year, class_cd)
        const get_data2 = get_func2(year, class_cd, term_cd)
        if (
          typeof get_data === 'object' &&
          typeof get_data2 === 'object' &&
          get_data.length > 0 &&
          get_data2.length > 0 &&
          get_data.length == get_data2.length
        ) {
          return true
        }
        return false
      }
    },
    get_member_license_filter_year_class_term: function () {
      const get_func = this.get_member_license_filter_year_class
      return function (year, class_cd, term_cd) {
        const get_data = get_func(year, class_cd)
        if (typeof get_data === 'object') {
          return get_data.filter(
            license => parseInt(license.license_term_cd) == parseInt(term_cd)
          )
        }
        return false
      }
    },
    get_member_license_filter_year_class_terms: function () {
      const get_func = this.get_member_license_filter_year_class
      return function (year, class_cd, term_cd_list) {
        const get_data = get_func(year, class_cd)
        if (typeof get_data === 'object') {
          return get_data.filter(license =>
            term_cd_list.includes(parseInt(license.license_term_cd))
          )
        }
        return false
      }
    },
    license_year_list: function () {
      const tmps = []
      for (let y = common.getNowYear() - 5; y <= common.getNowYear(); y++) {
        tmps.push({
          key: y,
          label: y + '年'
        })
      }

      return tmps.sort((a, b) => {
        if (parseInt(a.key) > parseInt(b.key)) {
          return -1
        } else {
          return 1
        }
      })
    },
    get_list_param: function () {
      const get_func_list = {
        event: this.get_event_data,
        license: this.get_license_data,
        license_class: this.get_class_data,
        license_category: this.get_category_data,
        affiliation_type: this.get_affiliation_type
      }
      return function (key, code, param) {
        const get_data = get_func_list[key](code)
        if (
          typeof get_data === 'object' &&
          (typeof get_data[param] === 'string' ||
            typeof get_data[param] === 'number')
        ) {
          return get_data[param]
        }
        return code
      }
    },
    get_affiliation_type: function () {
      const affiliation_type_list = this.affiliation_type_list
      return function (affiliation_cd) {
        return affiliation_type_list.find(
          affiliation => affiliation.key == affiliation_cd
        )
      }
    },
    get_event_data: function () {
      const event_cd_list = this.event_cd_list
      return function (event_cd) {
        return event_cd_list.find(event => event.event_cd == event_cd)
      }
    },
    get_license_data: function () {
      const license_cd_list = this.license_cd_list
      return function (license_cd) {
        return license_cd_list.find(license => license.license_cd == license_cd)
      }
    },
    get_class_data: function () {
      const class_list = this.license_class_list
      return function (class_cd) {
        return class_list.find(cls => cls.key == class_cd)
      }
    },
    get_category_data: function () {
      const category_list = this.license_category_list
      return function (category_cd) {
        return category_list.find(cate => cate.key == category_cd)
      }
    },
    event_cd_list: function () {
      const lists = [...this.event_cd_obj]
      return lists
        .map(list => {
          list.key = list.id
          return list
        })
        .sort((a, b) => {
          if (parseInt(a.sort) < parseInt(b.sort)) {
            return -1
          } else {
            return 1
          }
        })
    },
    license_cd_list: function () {
      const lists = [...this.license_cd_obj]
      return lists
        .map(list => {
          list.key = list.id
          // list.class_label = this.get_list_param('license_class', list.license_class, 'label');
          // list.category_label = this.get_category_label('license_category', list.license_category, 'label');
          return list
        })
        .sort((a, b) => {
          if (parseInt(a.sort) < parseInt(b.sort)) {
            return -1
          } else {
            return 1
          }
        })
    },
    license_cd_list_filter_event: function () {
      const lists = [...this.license_cd_list]
      return function (event_cd, license_class) {
        console.log('license_cd_list_filter_event', event_cd, license_class)
        if (!event_cd) return []
        if (!license_class) return []
        return lists.filter(list => {
          if (
            list.license_event_cd == event_cd &&
            list.license_class == license_class
          ) {
            return true
          }
          return false
        })
      }
    },
    license_class_list: function () {
      const lists = [...this.license_class_obj]
      return lists
    },
    license_category_list: function () {
      const lists = [...this.license_category_obj]
      return lists
    },
    application_type_list: function () {
      return this.application_type_obj
    },
    application_check_type_list: function () {
      return this.application_check_type_obj
    },
    application_type_group_list: function () {
      const tmps = []
      if (
        typeof this.application_type_group_obj === 'object' &&
        typeof (this.application_type_group_obj || {}).label === 'object' &&
        typeof (this.application_type_group_obj || {}).cds === 'object'
      ) {
        Object.keys((this.application_type_group_obj || {}).label).forEach(
          lbl_key => {
            if (
              (this.application_type_group_obj || {}).cds[lbl_key] &&
              parseInt(
                (this.application_type_group_obj || {}).cds[lbl_key].key
              ) <= 9999
            ) {
              tmps.push({
                key: (this.application_type_group_obj || {}).cds[lbl_key].label,
                label: (this.application_type_group_obj || {}).label[lbl_key]
                  .label
              })
            }
          }
        )
      }
      return tmps
    },

    pref_list: function () {
      const lists = [...this.pref_obj]
      return lists.sort((a, b) => {
        if (parseInt(a.sort) < parseInt(b.sort)) {
          return -1
        } else {
          return 1
        }
      })
    },
    group_list: function () {
      return []
    },
    insurance_type_list: function () {
      const lists = [...this.insurance_type_obj]
      return lists
    },
    belong_club_status_list: function () {
      const lists = [...this.belong_club_status_obj]
      return lists
    },
    affiliation_type_list: function () {
      const lists = [...this.affiliation_type_obj]
      return lists
    },
    continue_app_type_list: function () {
      return this.continue_app_type_obj
    },
    continue_data_save_type_list: function () {
      return this.continue_data_save_type_obj
    },
    request_type_list: function () {
      return this.request_type_cd_obj
    },
    identify_type_list: function () {
      return this.identify_type_cd_obj
    },
    exclude_list: function () {
      return this.exclude_cd_obj
    },
    dead_or_live_list: function () {
      return this.dead_or_live_obj
    },
    member_assets_list: function () {
      return this.member_assets_cd_obj
    },
    member_document_list: function () {
      return this.member_document_cd_obj
    },

    not_add: function () {
      return this.targetid != 'add' && !Number.isNaN(this.targetid)
        ? true
        : false
    },
    tabDisplay: function () {
      const self_tab_active = this.tab_active
      return function (tab) {
        let tabClass = 'd-none '
        if (self_tab_active == tab) {
          tabClass = 'd-block'
        }
        return tabClass
      }
    },
    tab_switch: function () {
      const self_tab_active = this.tab_active
      return function (tab) {
        let tabClass = 'nav-link '
        // console.log('tab_switch', self_tab_active);
        if (self_tab_active == tab) {
          tabClass += 'active'
        }
        return tabClass
      }
    },
    circuit_list: function () {
      const lists = [...this.circuit_obj]
      return lists
        .map(list => {
          list.key = list.id
          // list.class_label = this.get_list_param('license_class', list.license_class, 'label');
          // list.category_label = this.get_category_label('license_category', list.license_category, 'label');
          return list
        })
        .sort((a, b) => {
          if (parseInt(a.sort) < parseInt(b.sort)) {
            return -1
          } else {
            return 1
          }
        })
    },
    get_clinic_data: function () {
      const clinic_list = this.clinic_list
      return function (clinic_id) {
        return clinic_list.find(clinic => {
          return clinic.id == clinic_id
        })
      }
    },
    get_clinic_label: function () {
      const get_clinic_data = this.get_clinic_data
      return function (clinic_id) {
        return get_clinic_data(clinic_id).label
      }
    }
  },

  async created() {
    await this.loadLicenseCdList()
    await this.loadEventCdList()
    await this.loadLicenseClassList()
    await this.loadLicenseCategoryList()
    await this.loadLicenseTypeObj()
    await this.loadPrefList()
    await this.loadSexType()
    await this.loadCircuitList()
    await this.loadLicenseNoStock()
    const tmps = await this.getConfigListsAPI([
      'affiliation_type',
      'insurance_type',
      'belong_club_status',
      'continue_app_type',
      'continue_data_save_type',
      'request_type_cd',
      'identify_type_cd',
      'exclude_cd',
      'dead_or_live',
      'member_assets_cd',
      'member_document_cd',
      'license_term_cd',
      'application_check_type',
      'application_type',
      'application_type_group'
    ])

    await Promise.all(
      Object.entries(tmps).map(async ([key, value]) => {
        if (Array.isArray(value) && value.length > 0) {
          this[key + '_obj'] = value
        } else {
          this[key + '_obj'] = []
        }
      })
    )
    // await this.loadConfigObj('affiliation_type')
    // await this.loadConfigObj('insurance_type')
    // await this.loadConfigObj('belong_club_status')
    // await this.loadConfigObj('continue_app_type')
    // await this.loadConfigObj('continue_data_save_type')
    // await this.loadConfigObj('request_type_cd')
    // await this.loadConfigObj('identify_type_cd')
    // await this.loadConfigObj('exclude_cd')
    // await this.loadConfigObj('dead_or_live')
    // await this.loadConfigObj('member_assets_cd')
    // await this.loadConfigObj('member_document_cd')
    // await this.loadConfigObj('license_term_cd')
    // await this.loadConfigObj('application_check_type')
    // await this.loadConfigObj('application_type')
    // await this.loadConfigObj('application_type_group')

    if (Number.isNaN(this.targetid)) {
      this.$router.push({ path: '/' })
    } else if (this.targetid != 'add' && !Number.isNaN(this.targetid)) {
      await this.loadMemberObj()
      this.btnLabel = '更新'
    } else {
      await this.toggle_change_mode()
      this.member_obj = Object.assign({
        id: 0,
        stat: 1,
        name_1: '',
        name_2: '',
        name_3: '',
        yomi_1: '',
        yomi_2: '',
        yomi_3: '',
        login_id: '',
        birth_date: '',
        sex_type: 'unanswered',
        license_no: '',
        live_flg: 'live',
        live_flg_now: 'live',
        identify_type: '',
        identify_manage_id: '',
        identify_date: '',
        continue_app_type: 0,
        continue_data_save_type: 0,
        application_date: '',
        permission_date: '',
        permission_manage_id: '',
        payment_date: '',
        identify_sw: false,
        identify_manage_label: '',
        permission_sw: false,
        permission_manage_label: '',
        identify_date_date: '',
        application_date_date: '',
        permission_date_date: '',
        payment_date_date: '',
        profile: [],
        insurance: [],
        circuit_license: [],
        belong_club: [],
        system_exclude: [],
        member_parent: [],
        member_note: [],
        member_assets: [],
        member_license: []
      })
      this.btnLabel = '登録'

      // set
      // this.member_obj.profile.push({...this.profile_column});
      // this.member_obj.insurance.push({...this.insurance_column});
      this.oParam.forEach(param => {
        const param_key = param + '_column'
        if (this.member_obj[param] === false) {
          this.member_obj[param] = []
          this.member_error_obj[param] = []
        }
        if (
          typeof this.member_obj[param] !== 'object' ||
          (typeof this.member_obj[param] === 'object' &&
            this.member_obj[param].length <= 0)
        ) {
          this.member_obj[param].push({ ...this[param_key] })
        }
      })
      const member_license = Array.isArray(this.member_obj.member_license)
        ? [...this.member_obj.member_license]
        : []
      if (member_license.length > 0) {
        this.member_obj.member_license = member_license.map(license => {
          license.yearkey = license.license_year
          return license
        })
      }
    }
    this.alertMessage = this.btnLabel + 'できます'
    if (!this.not_add) {
      this.change_mode = false
    }
    this.$forceUpdate()
  },
  mounted: function () {
    this.fromParentTitle = '会員データ'
    // console.log('tags_list', this.tags_list);
  },
  props: {}
}
</script>
